import React, { useState, useLayoutEffect, useEffect, useMemo, useCallback, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { debounce } from 'lodash';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { saveAs } from 'file-saver';
import {
  Container,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  Input,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Button,
  TabContent,
  TabPane,
  UncontrolledButtonDropdown,
  Dropdown,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Progress
} from 'reactstrap';
import { ReactTabulator } from 'react-tabulator';
import NavBar from '../components/NavBar';
import { REQUEST_URL } from '../config/urls.js';
import 'react-toastify/dist/ReactToastify.css';
import 'tabulator-tables/dist/css/tabulator.min.css';



const cssExtra = `
  :root {
    --cor-primaria: #4f46e5;
    --cor-secundaria: #6b7280;
    --cor-sucesso: #10b981;
    --cor-fundo: #ffffff;
    --cor-fundo-claro: #f9fafb;
    --cor-borda: #e5e7eb;
    --cor-texto: #111827;
    --cor-texto-claro: #6b7280;
    --cor-hover: #f3f4f6;
    --cor-destaque: #eff6ff;
    --cor-sombra: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    --cor-sombra-forte: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .header-with-filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
  }
  .filter-button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    color: var(--cor-texto-claro);
    transition: all 0.2s;
  }
  .filter-button:hover {
    background: var(--cor-hover);
    color: var(--cor-primaria);
  }
  .filter-button.active {
    color: var(--cor-primaria);
    background: var(--cor-destaque);
  }
  .filtro-popup {
    position: absolute;
    background: white;
    border: 1px solid var(--cor-borda);
    border-radius: 8px;
    box-shadow: var(--cor-sombra-forte);
    padding: 16px;
    z-index: 1000;
    min-width: 250px;
    max-height: 400px;
    overflow-y: auto;
  }
  .filtro-popup .search-input {
    width: 100%;
    padding: 8px;
    border: 1px solid var(--cor-borda);
    border-radius: 4px;
    margin-bottom: 8px;
  }
  .filtro-popup .options-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .filtro-popup .option-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px;
  }
  .filtro-popup .option-item:hover {
    background: var(--cor-hover);
    border-radius: 4px;
  }
  .limpar-filtros {
    margin-left: 8px;
    padding: 6px 12px;
    background: var(--cor-fundo-claro);
    border: 1px solid var(--cor-borda);
    border-radius: 4px;
    color: var(--cor-texto);
    cursor: pointer;
    transition: all 0.2s;
  }
  .limpar-filtros:hover {
    background: var(--cor-hover);
    color: var(--cor-primaria);
  }

  .column-filter-menu {
    background: var(--cor-fundo);
    border-radius: 8px;
    padding: 14px;
    min-width: 220px;
    max-width: 300px;
    box-shadow: var(--cor-sombra-forte);
  }

  .column-filter-search {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid var(--cor-borda);
    border-radius: 6px;
    font-size: 0.875rem;
    margin-bottom: 10px;
    outline: none;
    transition: all 0.2s ease;
    font-family: inherit;
  }

  .column-filter-search:focus {
    border-color: var(--cor-primaria);
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  }

  .column-filter-option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 0.875rem;
    transition: background-color 0.2s ease;
  }

  .column-filter-option:hover {
    background-color: var(--cor-hover);
  }

  .column-filter-option input[type="checkbox"] {
    cursor: pointer;
    width: 16px;
    height: 16px;
    margin: 0;
  }

  .column-filter-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid var(--cor-borda);
  }

  .column-filter-btn-small {
    flex: 1;
    padding: 8px 14px;
    border-radius: 6px;
    font-size: 0.813rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
    outline: none;
    font-family: inherit;
    text-align: center;
    white-space: nowrap;
    min-height: 34px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .column-filter-btn-small.clear {
    background: var(--cor-fundo);
    color: var(--cor-texto);
    border: 1px solid var(--cor-borda);
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  }

  .column-filter-btn-small.clear:hover {
    background-color: var(--cor-hover);
    color: var(--cor-texto);
    border-color: var(--cor-texto-claro);
    box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  }

  .column-filter-btn-small.apply {
    background-color: var(--cor-primaria);
    color: white;
    border: 1px solid var(--cor-primaria);
    box-shadow: 0 2px 4px rgba(79, 70, 229, 0.3);
  }

  .column-filter-btn-small.apply:hover {
    background-color: #3730a3;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(79, 70, 229, 0.4);
  }

  .column-filter-btn-small:active {
    transform: translateY(0);
  }

  * {
    box-sizing: border-box;
  }
  
  body { 
    background-color: var(--cor-fundo-claro); 
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    color: var(--cor-texto);
    line-height: 1.5;
    overflow-x: hidden;
    margin: 0;
    padding: 0;
  }
  
  .page-header {
    background: var(--cor-fundo);
    border-radius: 8px;
    padding: 1rem 1.5rem;
    margin-bottom: 1rem;
    border: 1px solid var(--cor-borda);
    box-shadow: var(--cor-sombra);
  }
  
  .page-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--cor-texto);
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .page-subtitle {
    color: var(--cor-texto-claro);
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }
  
  .table-container-card {
    border: none;
    border-radius: 8px;
    overflow: auto;
    background: var(--cor-fundo);
    border: 1px solid var(--cor-borda);
    box-shadow: var(--cor-sombra-forte);
    height: calc(90vh - 120px);
  }
  
  .tabulator {
    border: none;
    background: transparent;
    height: 100%;
    width: 100%;
    font-size: 0.875rem;
  }
  
  .tabulator .tabulator-header {
    background: var(--cor-fundo);
    border-bottom: 2px solid var(--cor-borda);
    color: var(--cor-texto);
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    height: 56px;
    min-height: 56px;
  }
  
  .tabulator .tabulator-header .tabulator-col {
    background-color: transparent;
    border-right: 1px solid var(--cor-borda);
    padding: 0 0.75rem;
    height: 56px;
    line-height: 56px;
    position: relative;
  }
  
  .tabulator .tabulator-header .tabulator-col:last-child {
    border-right: none;
  }
  
  .tabulator .tabulator-header .tabulator-col.tabulator-sortable .tabulator-col-title {
    padding-right: 1.25rem;
  }
  
  .tabulator .tabulator-row {
    border-bottom: 1px solid var(--cor-borda);
    height: 56px;
    min-height: 56px;
    max-height: none;
    transition: background-color 0.2s ease;
  }
  
  .tabulator .tabulator-row:hover {
    background-color: var(--cor-hover);
  }
  
  .tabulator .tabulator-row .tabulator-cell {
    padding: 0 0.75rem;
    border-right: 1px solid var(--cor-borda);
    font-size: 0.875rem;
    height: 56px;
    line-height: 56px;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .tabulator .tabulator-row .tabulator-cell:last-child {
    border-right: none;
  }
  
  .tabulator-row.tabulator-tree-level-0 {
    font-weight: 600;
    background-color: var(--cor-destaque);
    border-top: 1px solid var(--cor-borda);
    border-bottom: 1px solid var(--cor-borda);
  }
  
  .tabulator-row.tabulator-tree-level-0 .tabulator-cell {
    color: var(--cor-texto);
  }
  
  .tabulator-row.tabulator-tree-level-1:nth-of-type(even) { 
    background-color: var(--cor-fundo-claro); 
  }
  

  .status-badge {
    padding: 0.375rem 0.75rem;
    border-radius: 6px;
    font-weight: 500;
    font-size: 0.75rem;
    text-transform: uppercase;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    height: 28px;
    line-height: 1;
    min-width: 80px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
    transition: all 0.2s ease;
  }
  
  .status-badge-link {
    text-decoration: none !important;
    display: inline-block;
  }
  
  .status-badge-link:hover .status-badge {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    opacity: 0.9;
  }
  

  .timeline-visual {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    cursor: default;
    padding: 6px 0;
    position: relative;
    overflow: hidden; /* Remove a barra de rolagem */
  }
  
  .timeline-year {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    border: 2px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
    position: relative;
    transition: all 0.2s ease;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    flex-shrink: 0;
  }
  
  .timeline-year.has-data {
    color: white;
    transform: scale(1.05);
    border-color: rgba(255,255,255,0.3);
  }
  
  .timeline-year.current {
    border: 2px solid var(--cor-primaria);
    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.3);
    z-index: 2;
  }
  
  .timeline-year:hover {
    transform: scale(1.1);
    z-index: 3;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  }
  
 
  .timeline-tooltip-container {
    position: fixed;
    pointer-events: none;
    z-index: 10000;
    opacity: 0;
    transition: opacity 0.2s ease;
    background: rgba(0,0,0,0.9);
    color: white;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 13px;
    white-space: nowrap;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    max-width: 280px;
  }
  

  .instituicao-com-historico {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    max-width: calc(100% - 30px);
    height: 56px;
    line-height: 56px;
    vertical-align: middle;
  }

  .instituicao-nome {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;
    padding-left: 0;
    margin-left: 0;
  }

  /* Adicionar espaço para o botão de expansão na coluna instituição */
  .tabulator-cell[tabulator-field="nomeintituicao"] {
    padding-left: 2px !important;
  }

  .tabulator-row.tabulator-tree-level-0 .tabulator-cell[tabulator-field="nomeintituicao"] {
    padding-left: 2px !important;
  }

  /* Garantir que o nome da instituição fique próximo ao botão de expansão */
  .tabulator-row.tabulator-tree-level-0 .tabulator-cell[tabulator-field="nomeintituicao"] .tabulator-data-tree-control {
    margin-right: 4px !important;
    display: inline-block;
    vertical-align: middle;
  }
  
  .historico-icon-btn {
    background: none;
    border: none;
    color: var(--cor-primaria);
    cursor: pointer;
    padding: 6px;
    margin-left: 8px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    transition: all 0.2s ease;
  }
  
  .historico-icon-btn:hover {
    background-color: rgba(79, 70, 229, 0.1);
    transform: scale(1.05);
  }
  

  .vendedor-cell {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 56px;
    line-height: 56px;
  }
  
  .vendedor-name-cell {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 56px;
    line-height: 56px;
    font-weight: 500;
  }
  
  .vendedor-btn-cell {
    padding: 0.375rem 0.75rem;
    font-size: 0.60rem;
    border-radius: 6px;
    background-color: var(--cor-primaria);
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    height: 25px;
    line-height: 1;
    margin-left: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
    white-space: nowrap;
  }
  
  .vendedor-btn-cell:hover {
    background-color: #3730a3;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }
  

  .tabulator-tableholder {
    width: 100% !important;
    height: 100% !important;
    overflow-x: auto !important;
  }
  
  .tabulator-table {
    width: 100% !important;
  }
    
  

  .tabulator-col[data-field="statusGrupo"],
  .tabulator-col[data-field="tempoValidade"] {
    width: 120px !important;
    min-width: 110px !important;
    max-width: 140px !important;
  }
  
  .tabulator-col[data-field="historicoValido"] {
    width: 170px !important;
    min-width: 150px !important;
    max-width: 190px !important;
  }
  

  .tabulator-col[data-field="timeline"] {
    width: 240px !important;
    min-width: 220px !important;
    max-width: 260px !important;
  }
  
  .tabulator .tabulator-row .tabulator-cell[field="timeline"] {
    padding: 0.5rem 0.4rem !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  

  .tabulator-col[data-field="solicitacao"] {
    width: 150px !important;
    min-width: 130px !important;
    max-width: 170px !important;
  }
  
  /* Ajustes para a coluna Relacionar Vendedor */
  .tabulator-col[data-field="relacionar_vendedor"] {
    width: 140px !important;
    min-width: 130px !important;
    max-width: 150px !important;
  }
  
  .tabulator .tabulator-row .tabulator-cell[field="relacionar_vendedor"] {
    padding: 0.5rem 0.4rem !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .relacionar-vendedor-btn {
    padding: 0.375rem 0.75rem;
    font-size: 0.75rem;
    border-radius: 6px;
    background-color: var(--cor-primaria);
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    height: 32px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
    white-space: nowrap;
    width: 100%;
    max-width: 120px;
  }
  
  .relacionar-vendedor-btn:hover {
    background-color: #3730a3;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }
  

  .tabulator .tabulator-row .tabulator-cell[field="statusGrupo"],
  .tabulator .tabulator-row .tabulator-cell[field="tempoValidade"],
  .tabulator .tabulator-row .tabulator-cell[field="historicoValido"],
  .tabulator .tabulator-row .tabulator-cell[field="solicitacao"] {
    white-space: normal;
    word-wrap: break-word;
    overflow: visible;
    text-overflow: clip;
    padding: 0.5rem 0.4rem;
    line-height: 1.3;
    height: auto;
    min-height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  

  .tabulator .tabulator-row .tabulator-cell[field="tempoValidade"] {
    font-size: 0.8rem;
  }
  

  .tabulator-row .tabulator-cell .tabulator-data-tree-control {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1.5px solid #4f46e5;
    margin-right: 8px;
    background: #4f46e5;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 3px rgba(79, 70, 229, 0.3);
    flex-shrink: 0;
  }

  .tabulator-row .tabulator-cell .tabulator-data-tree-control:hover {
    background: #3730a3;
    border-color: #3730a3;
    transform: scale(1.05);
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.4);
  }

  .tabulator-data-tree-control-expand::before,
  .tabulator-data-tree-control-collapse::before {
    content: '+';
    color: white;
    font-size: 16px;
    font-weight: bold;
    transition: transform 0.2s ease;
    display: block;
  }

  .tabulator-row.tabulator-tree-expanded .tabulator-data-tree-control-collapse::before {
    transform: rotate(90deg);
  }

  /* Adicionar indicação visual na linha pai */
  .tabulator-row.tabulator-tree-level-0 {
    cursor: pointer;
    position: relative;
  }

  .tabulator-row.tabulator-tree-level-0::before {
    content: 'Clique para expandir e ver os anos/semestres';
    position: absolute;
    left: 10px;
    top: -18px;
    font-size: 0.7rem;
    color: #4f46e5;
    font-weight: 600;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
    background: rgba(255, 255, 255, 0.98);
    padding: 5px 10px;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(79, 70, 229, 0.2);
    border: 1px solid #c7d2fe;
    z-index: 10;
  }

  .tabulator-row.tabulator-tree-level-0:hover::before {
    opacity: 1;
  }

  .tabulator-row.tabulator-tree-level-0.tabulator-tree-expanded::before {
    content: 'Clique para recolher';
  }
  
  .modal-timeline-table {
    margin-top: 16px;
  }
  
  .modal-timeline-table th {
    background-color: var(--cor-fundo-claro);
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.75rem;
    padding: 12px;
    border-bottom: 2px solid var(--cor-borda);
  }
  
  .modal-timeline-table td {
    padding: 12px;
    border-bottom: 1px solid var(--cor-borda);
  }
  
  .status-tooltip-container {
    position: relative;
    display: inline-block;
  }
  
  .status-tooltip {
    position: absolute;
    background: rgba(0,0,0,0.9);
    color: white;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
    max-width: 200px;
    text-align: center;
  }
  
  .status-tooltip::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0,0,0,0.9) transparent transparent transparent;
  }
  
  .status-tooltip-container:hover .status-tooltip {
    opacity: 1;
  }

  /* Estilos para tooltips dos cabeçalhos das colunas */
  .column-header-tooltip {
    position: relative;
    cursor: help;
    transition: all 0.2s ease;
  }

  .column-header-tooltip:hover {
    color: var(--cor-primaria);
    text-shadow: 0 0 8px rgba(79, 70, 229, 0.3);
  }

  /* Tooltip customizada para cabeçalhos */
  .header-tooltip {
    position: fixed;
    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
    color: white;
    padding: 12px 16px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 500;
    z-index: 10000;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    max-width: 250px;
    text-align: center;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    line-height: 1.4;
    white-space: normal;
    word-wrap: break-word;
    transform: translateX(-50%) translateY(-10px);
  }

  .header-tooltip.show {
    opacity: 1;
    transform: translateX(-50%) translateY(-2px);
  }

  .header-tooltip::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: #1f2937 transparent transparent transparent;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  }
  
  .search-container {
    position: relative;
    max-width: 320px;
  }
  
  .search-input {
    border-radius: 8px;
    border: 1px solid var(--cor-borda);
    padding-left: 2.75rem;
    padding-right: 2.75rem;
    height: 40px;
    font-size: 0.875rem;
    transition: all 0.2s ease;
  }
  
  .search-input:focus {
    border-color: var(--cor-primaria);
    outline: none;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.2);
  }
  
  .search-icon {
      position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: var(--cor-texto-claro);
  }
  
  .clear-search {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: var(--cor-texto-claro);
    cursor: pointer;
    font-size: 1.125rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    transition: all 0.2s ease;
  }
  
  .clear-search:hover {
    background-color: var(--cor-hover);
    color: var(--cor-texto);
  }
  
  .filter-button {
    border-radius: 8px;
    padding: 0.625rem 1.25rem;
    font-weight: 500;
    border: 1px solid var(--cor-borda);
    background: var(--cor-fundo);
    color: var(--cor-texto);
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    transition: all 0.2s ease;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  }
  
  .filter-button:hover {
    background-color: var(--cor-hover);
    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
  }
  
  .btn-vendedor {
    padding: 0.375rem 0.75rem;
    font-size: 0.75rem;
    border-radius: 6px;
    background-color: var(--cor-primaria);
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  }
  
  .btn-vendedor:hover {
    background-color: #3730a3;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }
  
  .filter-menu {
    background: var(--cor-fundo);
    border-radius: 8px;
    box-shadow: var(--cor-sombra-forte);
    border: 1px solid var(--cor-borda);
    padding: 1rem;
    min-width: 300px;
    max-width: 340px;
    max-height: 70vh;
    overflow-y: auto;
  }
  
  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid var(--cor-borda);
  }
  
  .filter-title {
    font-weight: 600;
    color: var(--cor-texto);
    font-size: 1rem;
  }
  
  .filter-tabs {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid var(--cor-borda);
    margin-bottom: 1rem;
    gap: 0.25rem;
  }
  
  .filter-tab {
    padding: 0.5rem 0.75rem;
    cursor: pointer;
    font-weight: 500;
    color: var(--cor-texto-claro);
    border-bottom: 2px solid transparent;
    transition: all 0.2s ease;
    border-radius: 6px 6px 0 0;
    font-size: 0.875rem;
  }
  
  .filter-tab:hover {
    color: var(--cor-primaria);
    background-color: var(--cor-hover);
  }
  
  .filter-tab.active {
    color: var(--cor-primaria);
    border-bottom-color: var(--cor-primaria);
    background-color: rgba(79, 70, 229, 0.05);
  }
  
  .filter-section {
    margin-bottom: 1rem;
  }
  
  .filter-section:last-child {
    margin-bottom: 0;
  }
  
  .filter-section-title {
    font-weight: 600;
    color: var(--cor-texto);
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
  }
  
  .filter-option {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.875rem;
    transition: background-color 0.2s ease;
  }
  
  .filter-option:hover {
    background-color: var(--cor-hover);
  }
  
  .filter-option input {
    margin-right: 0.75rem;
  }
  
  .filter-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
    padding-top: 0.75rem;
    border-top: 1px solid var(--cor-borda);
  }
  
  .filter-btn {
    padding: 0.5rem 1rem;
    border-radius: 6px;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 500;
  }
  
  .filter-btn.apply {
    background-color: var(--cor-primaria);
    color: white;
    border: none;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  }
  
  .filter-btn.apply:hover {
    background-color: #3730a3;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }
  
  .filter-btn.clear {
    background: transparent;
    color: var(--cor-texto-claro);
    border: 1px solid var(--cor-borda);
  }
  
  .filter-btn.clear:hover {
    background-color: var(--cor-hover);
    color: var(--cor-texto);
  }
  
  .filter-count {
    background-color: var(--cor-primaria);
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    margin-left: 0.5rem;
    font-weight: 600;
  }
  
  .loading-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 400px;
    gap: 1.5rem;
  }
  
  .loading-spinner {
    width: 48px;
    height: 48px;
    border: 4px solid var(--cor-borda);
    border-top: 4px solid var(--cor-primaria);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  .tabulator .tabulator-row .tabulator-cell[field="vendedor_id"] {
    cursor: pointer;
  }
  
  .tabulator .tabulator-row .tabulator-cell[field="vendedor_id"]:hover {
    background-color: var(--cor-hover);
  }
  
  .vendedor-dropdown {
    position: absolute;
    z-index: 1000;
    background-color: white;
    border: 1px solid var(--cor-borda);
    border-radius: 8px;
    box-shadow: var(--cor-sombra-forte);
    min-width: 220px;
    max-height: 320px;
    overflow-y: auto;
  }
  
  .vendedor-option {
    padding: 0.75rem 1rem;
    cursor: pointer;
    transition: background-color 0.2s ease;
    font-size: 0.875rem;
  }
  
  .vendedor-option:hover {
    background-color: var(--cor-hover);
  }
  


  .solicitacao-pendente, .solicitacao-aprovada, .solicitacao-rejeitada {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 2px 0;
  }

  .btn-solicitar-vinculacao, .btn-aprovacao, .btn-orcamento {
    padding: 4px 8px;
    font-size: 0.75rem;
    border-radius: 4px;
    background-color: var(--cor-primaria);
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
    height: 28px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 70px;
    font-weight: 600;
  }

  .btn-solicitar-vinculacao:hover, .btn-aprovacao:hover, .btn-orcamento:hover:not(:disabled) {
    background-color: #3730a3;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }

  .btn-orcamento {
    background-color: #28a745;
  }

  .btn-orcamento:hover:not(:disabled) {
    background-color: #218838;
  }

  .btn-orcamento:disabled {
    background: #e0e0e0;
    color: #999;
    cursor: not-allowed;
    opacity: 0.5;
  }
  


.dashboard-minimalista {
  display: flex;
  gap: 1rem; /* Aumentado de 0.6rem para 1rem */
  margin-left: 1rem; /* Mudado de auto para 1rem para posicionar à esquerda */
  margin-right: auto;
  align-items: center;
}

.dashboard-card {
  display: flex;
  align-items: baseline;
  padding: 0.4rem 1rem; /* Aumentado de 0.2rem 0.6rem */
  border-radius: 6px; /* Aumentado de 4px */
  background: var(--cor-fundo);
  border: 1px solid var(--cor-borda);
  border-left: 4px solid var(--card-status-color, var(--cor-borda)); /* Aumentado de 3px */
  white-space: nowrap;
  transition: all 0.2s ease;
  box-shadow: var(--cor-sombra);
}

.dashboard-card:hover {
    background: var(--cor-hover);
    transform: translateY(-2px); /* Aumentado de -1px */
    box-shadow: var(--cor-sombra-forte);
}

.dashboard-card .valor {
  font-size: 1.25rem; /* Aumentado de 0.9rem */
  font-weight: 700;
  color: var(--card-status-color, var(--cor-primaria));
  margin: 0;
  padding: 0;
  line-height: 1;
  margin-right: 0.5rem; /* Aumentado de 0.4rem */
}

.dashboard-card .label {
  font-size: 0.75rem; /* Aumentado de 0.65rem */
  font-weight: 500;
  color: var(--cor-texto-claro);
  margin: 0;
  padding: 0;
  line-height: 1;
  text-transform: uppercase;
}
  
  .dashboard-card .progress-container {
    width: 100%;
    margin-top: 0.5rem;
  }
  
  .dashboard-card .progress {
    height: 4px;
    border-radius: 2px;
  }

  /* Estados de carregamento do dashboard */
  .dashboard-minimalista.loading {
    opacity: 0.8;
  }

  .dashboard-card.loading {
    background: var(--cor-fundo-claro);
    animation: pulse 1.5s ease-in-out infinite;
  }

  .loading-indicator {
    color: var(--cor-primaria);
    animation: dots 1s infinite;
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.7; }
  }

  @keyframes dots {
    0%, 20% { content: '...'; }
    40% { content: ''; }
    60% { content: '.'; }
    80% { content: '..'; }
    100% { content: '...'; }
  }
  

  @media (max-width: 768px) {
    .page-title {
      font-size: 1.25rem;
    }
    
    .nav-tabs {
      flex-wrap: wrap;
    }
    
    .tabulator .tabulator-header .tabulator-col,
    .tabulator .tabulator-row .tabulator-cell {
      padding: 0.5rem 0.375rem;
      font-size: 0.75rem;
    }
    
    .filter-menu {
      min-width: 280px;
      max-width: 320px;
    }
    
    .filter-tabs {
      gap: 0.25rem;
    }
    
    .filter-tab {
      padding: 0.375rem 0.5rem;
      font-size: 0.75rem;
    }
    
    .search-container {
      max-width: 100%;
    }
    

    .timeline-visual {
      height: 40px !important;
      justify-content: space-around;
    }
    
    .timeline-year {
      width: 22px !important;
      height: 22px !important;
      font-size: 8px !important;
      margin: 0 1px !important;
    }
    

    .tabulator-col[data-field="timeline"] {
      width: 180px !important;
      min-width: 160px !important;
      max-width: 200px !important;
    }
    

    .tabulator-col[data-field="relacionar_vendedor"] {
      width: 100px !important;
      min-width: 90px !important;
      max-width: 110px !important;
    }
    
    .relacionar-vendedor-btn {
      padding: 0.25rem 0.5rem !important;
      font-size: 0.65rem !important;
      height: 28px !important;
      line-height: 1 !important;
      width: 100%;
      max-width: 90px;
    }
    
 
    .status-badge {
      padding: 0.25rem 0.5rem !important;
      border-radius: 4px !important;
      font-size: 0.7rem !important;
      height: 24px !important;
      line-height: 1 !important;
      min-width: 70px !important;
      max-width: 100% !important;
    }
    
    .tabulator .tabulator-row .tabulator-cell button {
      padding: 0.25rem 0.5rem !important;
      font-size: 0.7rem !important;
      height: 28px !important;
      line-height: 1 !important;
      border-radius: 4px !important;
      min-width: auto !important;
    }
    

    .btn-solicitar-vinculacao, .btn-aprovacao {
      padding: 0.25rem 0.5rem !important;
      font-size: 0.7rem !important;
      height: 28px !important;
      line-height: 1 !important;
      border-radius: 4px !important;
      display: inline-flex !important;
      visibility: visible !important;
      opacity: 1 !important;
    }
    

    .vendedor-btn-cell, .relacionar-vendedor-btn {
      padding: 0.25rem 0.5rem !important;
      font-size: 0.7rem !important;
      height: 28px !important;
      line-height: 1 !important;
      border-radius: 4px !important;
    }
    

    .historico-icon-btn {
      width: 28px !important;
      height: 28px !important;
      font-size: 16px !important;
      padding: 0 !important;
      margin-left: 6px !important;
    }
    

    .tabulator .tabulator-row .tabulator-cell[field="statusGrupo"],
    .tabulator .tabulator-row .tabulator-cell[field="tempoValidade"],
    .tabulator .tabulator-row .tabulator-cell[field="historicoValido"],
    .tabulator .tabulator-row .tabulator-cell[field="solicitacao"] {
      padding: 0.3rem 0.25rem !important;
    }
    

    .tabulator .tabulator-row .tabulator-cell {
      vertical-align: middle !important;
    }
    

    .tabulator .tabulator-row {
      height: 48px !important;
      min-height: 48px !important;
    }
    
    .tabulator .tabulator-row .tabulator-cell {
      height: 48px !important;
      line-height: 48px !important;
      padding: 0 0.5rem !important;
    }
    

    .tabulator .tabulator-header {
      height: 48px !important;
      min-height: 48px !important;
    }
    
    .tabulator .tabulator-header .tabulator-col {
      height: 48px !important;
      line-height: 48px !important;
      padding: 0 0.5rem !important;
    }
    

    .instituicao-com-historico {
      height: 48px !important;
      line-height: 48px !important;
    }
    
    .instituicao-nome {
      line-height: 48px !important;
      height: 48px !important;
    }
    
    /* Ajustar a célula do vendedor */
    .vendedor-cell {
      height: 48px !important;
      line-height: 48px !important;
    }
    
    .vendedor-name-cell {
      line-height: 48px !important;
      height: 48px !important;
    }
    

    .dashboard-minimalista {
      flex-wrap: wrap;
      justify-content: flex-end;
    }
    
    .dashboard-card {
      min-width: 90px;
      padding: 0.5rem 0.75rem;
    }
    
    .dashboard-card .valor {
      font-size: 1.2rem;
    }
    
    .dashboard-card .label {
      font-size: 0.7rem;
    }
  }
  
  @media (max-width: 992px) {
    .timeline-year {
      width: 26px;
      height: 26px;
      font-size: 9px;
    }
    
    .tabulator-col[data-field="statusGrupo"],
    .tabulator-col[data-field="tempoValidade"] {
      width: 100px !important;
      min-width: 90px !important;
    }
    
    .tabulator-col[data-field="historicoValido"] {
      width: 150px !important;
      min-width: 130px !important;
    }
    
    .tabulator-col[data-field="solicitacao"] {
      width: 130px !important;
      min-width: 110px !important;
    }
    
    .tabulator-col[data-field="timeline"] {
      width: 200px !important;
      min-width: 180px !important;
    }
    
    .tabulator-col[data-field="relacionar_vendedor"] {
      width: 120px !important;
      min-width: 110px !important;
    }
    
    .btn-solicitar-vinculacao {
      padding: 0.375rem 0.75rem;
      font-size: 0.75rem;
      height: 32px;
    }
 
  
  .filter-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  .limpar-filtro-individual-btn {
    background: none;
    border: none;
    color: var(--cor-primaria);
    cursor: pointer;
    font-size: 0.7rem;
    font-weight: 500;
    padding: 1px 2px;
    border-radius: 2px;
    transition: all 0.2s ease;
  }

  .limpar-filtro-individual-btn:hover {
    background-color: var(--cor-destaque);
    text-decoration: underline;
  }

  .pagination-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--cor-fundo);
  border-top: 1px solid var(--cor-borda);
  margin-top: 0;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.pagination-btn {
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--cor-borda);
  border-radius: 6px;
  background: var(--cor-fundo);
  color: var(--cor-texto);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: inherit;
  min-width: 2.5rem;
  height: 2.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  user-select: none;
}

.pagination-btn:hover:not(:disabled) {
  background: var(--cor-hover);
  border-color: var(--cor-primaria);
  color: var(--cor-primaria);
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: var(--cor-fundo-claro);
  color: var(--cor-texto-claro);
}

.pagination-btn.active {
  background: var(--cor-primaria);
  color: white;
  border-color: var(--cor-primaria);
}

.pagination-ellipsis {
  padding: 0.625rem 0.5rem;
  color: #64748b;
  font-weight: 600;
  user-select: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.75rem;
  height: 2.75rem;
  font-size: 1.2rem;
  opacity: 0.7;
}

.pagination-current-info {
  color: var(--cor-texto-claro);
  font-weight: 500;
  font-size: 0.875rem;
  text-align: center;
}

.pagination-btn:focus {
  outline: 2px solid #4f46e5;
  outline-offset: 2px;
}

.pagination-btn:focus:not(:focus-visible) {
  outline: none;
}

/* Garantir que os botões não herdem estilos indesejados */
.pagination-container button {
  all: unset;
  box-sizing: border-box;
}

.pagination-container .pagination-btn {
  padding: 0.625rem 0.875rem;
  border: 2px solid transparent;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  color: #475569;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  font-size: 0.875rem;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.9);
  min-width: 2.75rem;
  height: 2.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  user-select: none;
}

/* Estilos para indicador de carregamento */
.loading-more-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: var(--cor-fundo);
  border-top: 1px solid var(--cor-borda);
}

.loading-more-container p {
  margin: 10px 0 0 0;
  color: var(--cor-texto-claro);
  font-size: 0.875rem;
}

/* Responsividade melhorada */
@media (max-width: 768px) {
  .pagination-container {
    padding: 1.25rem 1rem;
    gap: 1rem;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  }

  .pagination-info {
    font-size: 0.8rem;
    text-align: center;
    padding: 0.4rem 0.8rem;
    background: rgba(255, 255, 255, 0.8);
  }

  .pagination-controls {
    gap: 0.25rem;
    flex-wrap: wrap;
    justify-content: center;
    padding: 0.6rem 0.8rem;
    background: rgba(255, 255, 255, 0.7);
  }

  .pagination-btn {
    padding: 0.5rem 0.65rem;
    font-size: 0.8rem;
    min-width: 2.25rem;
    height: 2.25rem;
    border-radius: 10px;
    font-weight: 600;
  }

  .pagination-btn.first-last {
    font-size: 0.75rem;
    min-width: 2.5rem;
  }

  .pagination-current-info {
    font-size: 0.8rem;
    padding: 0.5rem 1rem;
    border-radius: 16px;
  }

  .pagination-ellipsis {
    padding: 0.5rem 0.25rem;
    font-size: 1rem;
    min-width: 2.25rem;
    height: 2.25rem;
  }
}

@media (max-width: 480px) {
  .pagination-container {
    padding: 1rem 0.75rem;
    gap: 0.8rem;
  }

  .pagination-info {
    font-size: 0.75rem;
    line-height: 1.3;
    padding: 0.35rem 0.7rem;
  }

  .pagination-controls {
    gap: 0.2rem;
    padding: 0.5rem 0.6rem;
  }

  .pagination-btn {
    padding: 0.4rem 0.5rem;
    font-size: 0.75rem;
    min-width: 2rem;
    height: 2rem;
    border-radius: 8px;
  }

  .pagination-btn.first-last {
    min-width: 2.25rem;
    font-size: 0.7rem;
  }

  .pagination-current-info {
    font-size: 0.75rem;
    padding: 0.4rem 0.8rem;
  }

  .pagination-ellipsis {
    min-width: 2rem;
    height: 2rem;
    font-size: 0.9rem;
  }
}

/* Estilos para botão de exportação */
.export-button {
  background-color: var(--cor-sucesso);
  color: white;
  border: none;
  padding: 0.625rem 1.25rem;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.export-button:hover {
  background-color: #0d9c6b;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
}
`;


// Componente de Paginação Corrigido
const PaginationComponent = ({
  paginaAtual,
  totalPaginas,
  totalRegistros,
  registrosPorPagina,
  mudarPagina,
  carregando
}) => {
  const [inputPagina, setInputPagina] = React.useState('');

  const gerarNumerosPagina = () => {
    const paginas = [];
    const totalPag = totalPaginas;
    const atual = paginaAtual;

    if (totalPag <= 7) {
      for (let i = 1; i <= totalPag; i++) paginas.push(i);
    } else {
      if (atual <= 4) {
        for (let i = 1; i <= 5; i++) paginas.push(i);
        if (totalPag > 6) paginas.push('...');
        paginas.push(totalPag);
      } else if (atual >= totalPag - 3) {
        paginas.push(1);
        if (totalPag > 6) paginas.push('...');
        for (let i = totalPag - 4; i <= totalPag; i++) paginas.push(i);
      } else {
        paginas.push(1);
        paginas.push('...');
        for (let i = atual - 1; i <= atual + 1; i++) paginas.push(i);
        paginas.push('...');
        paginas.push(totalPag);
      }
    }
    return paginas;
  };

  const handleIrParaPagina = (e) => {
    e.preventDefault();
    const num = parseInt(inputPagina, 10);
    if (!isNaN(num) && num >= 1 && num <= totalPaginas) {
      mudarPagina(num);
      setInputPagina('');
    }
  };

  if (totalPaginas <= 1) return null;

  const inicio = (paginaAtual - 1) * registrosPorPagina + 1;
  const fim = Math.min(paginaAtual * registrosPorPagina, totalRegistros);

  return (
    <div className="pagination-container">
      {/* Info de registros */}
      <div style={{ fontSize: '0.8rem', color: 'var(--cor-texto-claro)', marginBottom: '6px', textAlign: 'center' }}>
        Exibindo <strong>{inicio}–{fim}</strong> de <strong>{totalRegistros.toLocaleString('pt-BR')}</strong> cursos &nbsp;|&nbsp; Página <strong>{paginaAtual}</strong> de <strong>{totalPaginas}</strong>
      </div>

      <div className="pagination-controls">
        <button
          type="button"
          className="pagination-btn"
          onClick={() => mudarPagina(1)}
          disabled={paginaAtual <= 1 || carregando}
          title="Primeira página"
        >
          «
        </button>

        <button
          type="button"
          className="pagination-btn"
          onClick={() => mudarPagina(paginaAtual - 1)}
          disabled={paginaAtual <= 1 || carregando}
        >
          ‹ Anterior
        </button>

        {gerarNumerosPagina().map((numeroPagina, index) => {
          if (numeroPagina === '...') {
            return <span key={`ellipsis-${index}`} className="pagination-ellipsis">…</span>;
          }
          return (
            <button
              type="button"
              key={numeroPagina}
              className={`pagination-btn ${numeroPagina === paginaAtual ? 'active' : ''}`}
              onClick={() => mudarPagina(numeroPagina)}
              disabled={carregando}
            >
              {numeroPagina}
            </button>
          );
        })}

        <button
          type="button"
          className="pagination-btn"
          onClick={() => mudarPagina(paginaAtual + 1)}
          disabled={paginaAtual >= totalPaginas || carregando}
        >
          Próxima ›
        </button>

        <button
          type="button"
          className="pagination-btn"
          onClick={() => mudarPagina(totalPaginas)}
          disabled={paginaAtual >= totalPaginas || carregando}
          title="Última página"
        >
          »
        </button>
      </div>

      {/* Ir para página */}
      <form onSubmit={handleIrParaPagina} style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '8px', justifyContent: 'center' }}>
        <span style={{ fontSize: '0.8rem', color: 'var(--cor-texto-claro)' }}>Ir para:</span>
        <input
          type="number"
          min="1"
          max={totalPaginas}
          value={inputPagina}
          onChange={e => setInputPagina(e.target.value)}
          disabled={carregando}
          style={{
            width: '60px',
            padding: '4px 8px',
            border: '1px solid var(--cor-borda)',
            borderRadius: '6px',
            fontSize: '0.8rem',
            textAlign: 'center',
            outline: 'none'
          }}
          placeholder={paginaAtual}
        />
        <button
          type="submit"
          disabled={carregando || !inputPagina}
          style={{
            padding: '4px 12px',
            borderRadius: '6px',
            background: 'var(--cor-primaria)',
            color: 'white',
            border: 'none',
            fontSize: '0.8rem',
            cursor: 'pointer',
            opacity: !inputPagina ? 0.5 : 1
          }}
        >
          Ir
        </button>
      </form>
    </div>
  );
};

const DashboardMinimalista = ({ summary, carregando }) => {
  // Configuração dos cards para facilitar a renderização e manutenção
  const dashboardCardsConfig = [
    {
      label: "Cursos",
      key: "totalInstituicoes",
      color: "#6b7280",
      descricao: "cursos (curso + instituição + cidade) com os filtros atuais"
    },
    {
      label: "CONTATO OK",
      key: "CONTATO OK",
      color: "#10b981",
      descricao: "cursos vinculados: turma recente com negócio no Bitrix"
    },
    {
      label: "SEM CONTATO",
      key: "SEM CONTATO",
      color: "#f59e0b",
      descricao: "cursos livres"
    },
    {
      label: "EM NEGOCIAÇÃO",
      key: "EM NEGOCIAÇÃO",
      color: "#007bff",
      descricao: "turmas de 2025 em diante em negociação no Bitrix"
    },
    {
      label: "FECHADOS",
      key: "FECHADOS",
      color: "#28a745",
      descricao: "turmas de 2025 em diante fechadas no Bitrix"
    },
    {
      label: "PERDIDO",
      key: "PERDIDO",
      color: "#dc3545",
      descricao: "turmas de 2025 em diante perdidas no Bitrix"
    }
  ];

  const getSummaryValue = (key) => {
    if (key === "totalInstituicoes") {

      return (summary && summary.totalInstituicoes) || 0;
    }

    return (summary && summary.statusCounts && summary.statusCounts[key]) || 0;
  };

  return (
    <div className={`dashboard-minimalista ${carregando ? 'loading' : ''}`}>
      {dashboardCardsConfig.map(card => (
        <div
          key={card.key}
          className={`dashboard-card ${carregando ? 'loading' : ''}`}
          style={{ '--card-status-color': card.color }}
          title={summary && summary.erro
            ? 'Não foi possível calcular os contadores agora'
            : `${getSummaryValue(card.key).toLocaleString()} ${card.descricao}${carregando ? ' (atualizando...)' : ''}`}
        >
          <span className="valor">
            {carregando ? (
              <span className="loading-indicator">...</span>
            ) : summary && summary.erro ? (
              '—'
            ) : (
              getSummaryValue(card.key).toLocaleString()
            )}
          </span>
          <span className="label">{card.label}</span>
        </div>
      ))}
    </div>
  );
};
const categoriaStatusCores = {
  "PERDIDO": "#dc3545",
  "FECHADOS": "#28a745",
  "EM NEGOCIAÇÃO": "#007bff",
  "Negociacao": "#007bff", // Status da database sem acento
  "Prospecto": "#17a2b8", // Status da database
  "Perdido": "#dc3545", // Status da database
  "Fechado": "#28a745", // Status da database
  "SEM CONTATO": "#e0e0e0",
  "CONTATO OK": "#a3d9ff",
  "REGIONAL": "#4f46e5",
  "HISTORICO": "#6b7280",
  "SOLICITADO": "#8a2be2"
};

const HISTORICO_VALIDO_CONFIG = {
  '1.1': { codigo: '1.1', descricao: 'CONTATO OK', cor: '#a3d9ff', duracao: 2 },
  '1': { codigo: '1', descricao: 'SEM CONTATO', cor: '#e0e0e0', duracao: 1 },
  '2': { codigo: '2', descricao: 'EM NEGOCIAÇÃO', cor: '#007bff', duracao: 2 },
  '3': { codigo: '3', descricao: 'FECHADOS', cor: '#28a745', duracao: 4 },
  '4': { codigo: '4', descricao: 'PERDIDO', cor: '#dc3545', duracao: 1 }
};



const STATUS_GRUPO = {
  LIVRE: { id: 1, descricao: 'Livre' },
  VINCULADO: { id: 2, descricao: 'Vinculado' }
};

function aplicarCabecalhoAuthAxios() {
  const token = sessionStorage.getItem('token');

  if (token) {
    axios.defaults.headers.common['Authorization'] = token;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
}

function RelatorioVendas() {
  const [usuarioLogado, setUsuarioLogado] = useState({});
  const [dados, setDados] = useState([]);
  const [dadosOriginais, setDadosOriginais] = useState([]);
  const [gruposHistoricos, setGruposHistoricos] = useState(new Map());
  const [carregando, setCarregando] = useState(true);
  const [buscaGlobal, setBuscaGlobal] = useState('');
  const [debouncedBuscaGlobal, setDebouncedBuscaGlobal] = useState('');
  const [filtros, setFiltros] = useState({
    categoriaStatus: [],
    vendedores: [],
    estados: [],
    instituicoes: [],
    cidades: [],
    cursos: [],
    turnos: [],
    anos: [],
    statusGrupo: [],
    siglas: []
  });

  const [opcoesFiltro, setOpcoesFiltro] = useState({
    categoriaStatus: [],
    vendedores: [],
    estados: [],
    instituicoes: [],
    cidades: [],
    cursos: [],
    anos: [],
    statusGrupo: [],
    siglas: []
  });

  const [filtrosColuna, setFiltrosColuna] = useState({});
  const [termoPesquisaFiltro, setTermoPesquisaFiltro] = useState('');
  const [atualizando, setAtualizando] = useState(false);
  const [gruposExpandidos, setGruposExpandidos] = useState(new Set());
  const [modalTimeline, setModalTimeline] = useState(false);
  const [timelineData, setTimelineData] = useState(null);
  const tableRef = useRef(null);
  const VENDEDORES_PERMITIDOS = [7, 9, 14, 15, 23, 26, 82, 81];
  const activeDropdownRef = useRef(null);

  // Função para salvar posição de scroll - VERSÃO ROBUSTA
  const salvarPosicaoScroll = useCallback(() => {
    try {
      const table = tableRef.current && tableRef.current.table;
      if (table && table.element) {
        const tableHolder = table.element.querySelector('.tabulator-tableholder');
        if (tableHolder) {
          const top = tableHolder.scrollTop;
          const left = tableHolder.scrollLeft;

          // Só salvar se houver scroll (evitar salvar posição 0,0 desnecessariamente)
          if (top > 0 || left > 0) {
            savedScrollPosition.current = { top, left };
          }
        }
      }
    } catch (error) {
      // Erro silencioso
    }
  }, []);

  // Função para restaurar posição de scroll - VERSÃO ROBUSTA
  const restaurarPosicaoScroll = useCallback(() => {
    try {
      const table = tableRef.current && tableRef.current.table;
      if (!table || !table.element || !savedScrollPosition.current) return;

      const { top, left } = savedScrollPosition.current;

      // Só restaurar se houver posição salva válida
      if (top === 0 && left === 0) return;

      const tableHolder = table.element.querySelector('.tabulator-tableholder');
      if (tableHolder) {
        // Usar requestAnimationFrame duplo para garantir que o DOM está pronto
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            tableHolder.scrollTop = top;
            tableHolder.scrollLeft = left;
          });
        });
      }
    } catch (error) {
      // Erro silencioso
    }
  }, []);
  const [pesquisaInstituicao, setPesquisaInstituicao] = useState('');
  const [pesquisaCurso, setPesquisaCurso] = useState('');
  const [pesquisaCidade, setPesquisaCidade] = useState('');
  const [pesquisaSigla, setPesquisaSigla] = useState('');
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [registrosPorPagina, setRegistrosPorPagina] = useState(50); // cursos por página
  const [totalPaginas, setTotalPaginas] = useState(0);
  const requestControllerRef = useRef(null);

  // NOVO ESTADO PARA O RESUMO
  const [summaryData, setSummaryData] = useState({ totalInstituicoes: 0, statusCounts: {} });
  const [carregandoSummary, setCarregandoSummary] = useState(false);

  // REF para preservar posição de scroll
  const savedScrollPosition = useRef({ top: 0, left: 0 });
  const dataProcessedTimeout = useRef(null);

  const [solicitacoes, setSolicitacoes] = useState([]);
  const [modalSolicitacao, setModalSolicitacao] = useState(false);
  const [modalAprovacao, setModalAprovacao] = useState(false);
  const [solicitacaoAtual, setSolicitacaoAtual] = useState(null);
  const [grupoSelecionado, setGrupoSelecionado] = useState(null);
  const [justificativa, setJustificativa] = useState('');
  const [motivoSolicitacao, setMotivoSolicitacao] = useState('');
  const [anoAtendimento, setAnoAtendimento] = useState('');
  const [semestreAtendimento, setSemestreAtendimento] = useState('');
  const [contatoSolicitacao, setContatoSolicitacao] = useState('');

  const solicitacoesRef = useRef(solicitacoes);
  const justificativaRef = useRef(justificativa);

  // ESTADO PARA CONTROLAR PERMISSÃO DO RELATÓRIO
  const [permissaoRelatorio, setPermissaoRelatorio] = useState('nenhum');

  useEffect(() => {
    solicitacoesRef.current = solicitacoes;
  }, [solicitacoes]);

  useEffect(() => {
    justificativaRef.current = justificativa;
  }, [justificativa]);


  useEffect(() => {
    // Debug removido por segurança
  }, [usuarioLogado, solicitacoes]);

  useEffect(() => {
    document.title = 'Mapa de Vendas | Gestão Comercial';
    try {
      const usuarioSessao = JSON.parse(sessionStorage.getItem('usuarioLogado'));
      const usuario = usuarioSessao && usuarioSessao[0] ? usuarioSessao[0] : {};
      if (usuario.idUsuario) {
        usuario.id = usuario.idUsuario;
      }
      setUsuarioLogado(usuario);

      // Carregar permissão do relatório
      const permissao = usuario.permissao_relatorio || 'nenhum';
      setPermissaoRelatorio(permissao);
    } catch (e) {
      // Erro ao parsear usuário
    }

    if (!sessionStorage.getItem('token')) {
      toast.error('Erro de autenticação. Por favor, faça o login novamente.');
      setCarregando(false);
      return;
    }

    aplicarCabecalhoAuthAxios();
  }, []);

  useEffect(() => {
    const carregarOpcoesFiltro = async () => {
      try {
        aplicarCabecalhoAuthAxios();
        const res = await axios.get(`${REQUEST_URL}/filtros`);

        const categoriasFixas = ["EM NEGOCIAÇÃO", "FECHADOS", "PERDIDO"].sort();

        setOpcoesFiltro({
          ...res.data,
          categoriaStatus: categoriasFixas
        });

      } catch (error) {
        toast.error("Não foi possível carregar as opções de filtro.");
      }
    };

    carregarOpcoesFiltro();
  }, []);

  // Atualização automática de solicitações a cada 30 segundos
  useEffect(() => {
    const intervalId = setInterval(async () => {
      // Salvar scroll antes de atualizar
      salvarPosicaoScroll();

      await carregarSolicitacoes();

      // Redesenhar APENAS células específicas ao invés de toda a tabela para evitar scroll reset
      if (tableRef.current && tableRef.current.table) {
        const table = tableRef.current.table;
        const rows = table.getRows();

        // Apenas reformatar linhas visíveis sem redraw completo
        rows.forEach(row => {
          if (row.reformat) {
            row.reformat();
          }
        });

        // Restaurar scroll após atualização
        setTimeout(() => restaurarPosicaoScroll(), 100);
      }
    }, 30000); // 30 segundos

    return () => clearInterval(intervalId);
  }, [carregarSolicitacoes, salvarPosicaoScroll, restaurarPosicaoScroll]);

  const categoriaStatusOptions = opcoesFiltro.categoriaStatus;
  const estadosOptions = opcoesFiltro.estados;
  const instituicoesOptions = opcoesFiltro.instituicoes;
  const cidadesOptions = opcoesFiltro.cidades;
  const cursosOptions = opcoesFiltro.cursos;
  const anosOptions = opcoesFiltro.anos;
  const siglasOptions = opcoesFiltro.siglas;

  const vendedores = useMemo(() => [
    { id: 7, nome: 'Rogerio Pinheiro' },
    { id: 10, nome: 'Elcio' },
    { id: 9, nome: 'Silene' },
    { id: 14, nome: 'Sandra' },
    { id: 15, nome: 'Haroldo' },
    { id: 23, nome: 'Marco Aurelio Custodio' },
    { id: 82, nome: 'Emily' },
    { id: 26, nome: 'Nilton' },
    { id: null, nome: 'A definir' }
  ], []);

  const limparFiltroIndividual = useCallback((tipoFiltro) => {
    setFiltros(prevFiltros => {
      // Capitaliza o nome do filtro para uma mensagem mais amigável
      const nomeFiltro = tipoFiltro.charAt(0).toUpperCase() + tipoFiltro.slice(1);
      toast.info(`Filtro '${nomeFiltro}' foi limpo.`);

      return {
        ...prevFiltros,
        [tipoFiltro]: [] // Redefine o array do filtro específico para vazio
      };
    });
  }, []);

  // nomeGravado: nome que veio do banco, para vendedor que não está na lista fixa acima
  const getNomeVendedor = useCallback((vendedorId, nomeGravado) => {
    if (!vendedorId) return 'A definir';
    const vendedor = vendedores.find(v => String(v.id) === String(vendedorId));
    if (vendedor) return vendedor.nome;
    return nomeGravado && String(nomeGravado).trim() !== '' ? nomeGravado : 'A definir';
  }, [vendedores]);

  const toggleFiltro = useCallback((tipo, valor) => {
    setFiltros(prev => {
      if (!prev[tipo]) {
        return prev;
      }

      const novosFiltros = { ...prev };
      const index = novosFiltros[tipo].indexOf(valor);

      if (index === -1) {
        novosFiltros[tipo] = [...novosFiltros[tipo], valor];
      } else {
        novosFiltros[tipo] = novosFiltros[tipo].filter(item => item !== valor);
      }

      return novosFiltros;
    });
  }, []);


  const debouncedToggleFiltro = useCallback(
    debounce((tipo, valor) => {
      toggleFiltro(tipo, valor);
    }, 300),
    [toggleFiltro]
  );

  const toggleGrupoInstituicao = useCallback((e, cell) => {
    e.preventDefault();
    e.stopPropagation();

    const row = cell.getRow();
    if (row && typeof row.treeToggle === 'function') {
      try {
        row.treeToggle();
      } catch (error) {
        // Erro ao alternar grupo
      }
    }
  }, []);

  const carregarSolicitacoes = useCallback(async () => {
    try {
      const response = await axios.get(`${REQUEST_URL}/solicitacoes-vinculacao?timestamp=${Date.now()}`);
      const dados = response.data || [];
      setSolicitacoes(dados);
    } catch (error) {
      toast.error('Não foi possível carregar as solicitações.');
    }
  }, []);



  const handleExtendRange = useCallback(async (cell) => {
    const table = cell.getTable();
    const row = cell.getRow();

    if (!row || !table) {
      toast.error('Ocorreu um erro interno na tabela (ref).');
      return;
    }

    const rowData = row.getData();
    const idCursoInst = rowData.id_curso_inst;
    const ano = rowData.Ano_Form;

    try {
      const res = await axios.put(`${REQUEST_URL}/extender-range`, {
        id_curso_inst: idCursoInst,
        ano: ano
      });

      if (res.data && res.data.novaDataFinal) {
        const novaData = res.data.novaDataFinal;

        await row.update({ range_end_date: novaData });

        row.reformat();

        toast.success('Range estendido em 60 dias!');
      } else {
        toast.error('Ocorreu um erro ao receber os dados atualizados.');
      }

    } catch (error) {
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        'Não foi possível estender o range.';
      toast.error(errorMessage);
    }
  }, []);




  const podeSolicitarVinculacao = useCallback((usuario) => {
    if (!usuario) return false;

    const nivel = usuario.Nivel ? usuario.Nivel.toUpperCase() : '';

    if (nivel === "RESTRITO") {
      const funcao = usuario.Funcao ? usuario.Funcao.toUpperCase() : '';
      if (funcao === "VENDEDOR") {
        return true;
      }
    }

    if (nivel === "SENIOR") {
      const funcao = usuario.Funcao ? usuario.Funcao.toUpperCase() : '';
      if (funcao === "ORCAMENTISTA") {
        return true;
      }
    }

    return VENDEDORES_PERMITIDOS.includes(Number(usuario.id));
  }, [VENDEDORES_PERMITIDOS]);

  // Função para verificar se o cliente já está em negociação baseada no status do ano mais recente (2025+)
  const verificarBloqueioSolicitacao = useCallback((grupoData) => {
    if (!grupoData || !grupoData._childrenHistorico || grupoData._childrenHistorico.length === 0) {
      return false; // Se não há histórico, permite solicitação
    }

    // Filtrar apenas registros de 2025 para frente (anos futuros/atuais) com status válido
    const registrosAnosRecentes = grupoData._childrenHistorico
      .filter(item => {
        const ano = parseInt(String(item.Ano_Form).split('/')[0], 10);
        return !isNaN(ano) && ano >= 2025 && item.CategoriaStatus &&
          item.CategoriaStatus.trim() !== '' &&
          item.CategoriaStatus !== 'SEM STATUS';
      })
      .sort((a, b) => {
        const anoA = parseInt(String(a.Ano_Form).split('/')[0], 10);
        const anoB = parseInt(String(b.Ano_Form).split('/')[0], 10);
        return anoB - anoA; // Ordem decrescente (mais recente primeiro)
      });

    if (registrosAnosRecentes.length === 0) {
      return false; // Se não há registros de anos recentes (2025+), permite solicitação
    }

    // Pegar o registro do ano mais recente (2025+) - primeiro da lista ordenada
    const registroMaisRecente = registrosAnosRecentes[0];
    const statusMaisRecente = registroMaisRecente.CategoriaStatus;

    // Indica "Em Negociação" se o status do ano mais recente (2025+) for "EM NEGOCIAÇÃO" ou "FECHADOS"
    return statusMaisRecente === 'EM NEGOCIAÇÃO' || statusMaisRecente === 'FECHADOS';
  }, []);

  const podeAprovarSolicitacoes = useCallback((usuario) => {
    if (!usuario) return false;

    const nivel = usuario.Nivel ? usuario.Nivel.toUpperCase() : '';
    const funcao = usuario.Funcao ? usuario.Funcao.toUpperCase() : '';

    if (funcao === "ORCAMENTISTA") {
      return true;
    }

    if (Number(usuario.id) === 81) {
      return true;
    }

    return false;
  }, []);

  const enviarSolicitacao = useCallback(async () => {

    if (!grupoSelecionado) {
      toast.error('Erro: Nenhum grupo selecionado para a solicitação.');
      return;
    }

    if (!anoAtendimento) {
      toast.error('Por favor, selecione o ano de atendimento.');
      return;
    }

    if (!semestreAtendimento) {
      toast.error('Por favor, selecione o semestre de atendimento.');
      return;
    }

    if (!contatoSolicitacao.trim()) {
      toast.error('O contato é obrigatório.');
      return;
    }

    if (!motivoSolicitacao.trim()) {
      toast.error('O motivo da solicitação é obrigatório.');
      return;
    }

    // Tentar pegar o id_representante da linha, ou id_curso_inst se for linha filha
    const idGrupo = grupoSelecionado.id_representante || grupoSelecionado.id_curso_inst;

    if (!idGrupo) {
      toast.error('Erro: ID do grupo não encontrado.');
      return;
    }

    const token = sessionStorage.getItem('token');
    if (!token) {
      toast.error('Erro de autenticação. Por favor, faça o login novamente.');
      return;
    }

    if (!podeSolicitarVinculacao(usuarioLogado)) {
      toast.error('Você não tem permissão para realizar esta ação.');
      return;
    }

    try {
      const url = `${REQUEST_URL}/solicitacoes-vinculacao`;
      await axios.post(
        url,
        {
          id_grupo: idGrupo,
          id_vendedor_vinculado: grupoSelecionado.vendedor_id || null,
          motivo: motivoSolicitacao,
          ano_atendimento: anoAtendimento,
          semestre_atendimento: semestreAtendimento,
          contato: contatoSolicitacao,
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      // Salvar scroll antes de atualizar
      salvarPosicaoScroll();

      // Recarregar solicitações primeiro
      await carregarSolicitacoes();

      // Fechar modal e limpar campos
      setModalSolicitacao(false);
      setMotivoSolicitacao('');
      setAnoAtendimento('');
      setSemestreAtendimento('');
      setContatoSolicitacao('');

      // Recarregar dados da tabela
      try {
        // Recarregar dados mantendo filtros
        await carregarDados(paginaAtual, registrosPorPagina, filtros, false);

        // Restaurar scroll após atualização
        setTimeout(() => restaurarPosicaoScroll(), 150);

        toast.success('Solicitação enviada com sucesso!');
      } catch (tableError) {
        toast.success('Solicitação enviada com sucesso! Atualize a página para ver as mudanças.');
      }
    } catch (error) {
      if (error.response) {
        toast.error(`Erro: ${error.response.data.message || 'Não foi possível enviar a solicitação.'}`);
      } else {
        toast.error('Erro de conexão ao enviar a solicitação.');
      }
    }
  }, [grupoSelecionado, carregarSolicitacoes, usuarioLogado, motivoSolicitacao, anoAtendimento, semestreAtendimento, contatoSolicitacao, podeSolicitarVinculacao, salvarPosicaoScroll, restaurarPosicaoScroll]);

  const aprovarSolicitacao = useCallback(async (id, aprovado) => {
    try {
      await axios.put(`${REQUEST_URL}/solicitacoes-vinculacao/${id}`, {
        status: aprovado ? 'aprovado' : 'rejeitado',
        justificativa: aprovado ? null : justificativaRef.current
      });
      toast.success(aprovado ? 'Solicitação aprovada!' : 'Solicitação rejeitada!');
      setModalAprovacao(false);
      setJustificativa('');

      // Salvar scroll antes de atualizar
      salvarPosicaoScroll();

      await carregarSolicitacoes();

      // Atualizar a tabela automaticamente SEM redraw completo para evitar scroll reset
      if (tableRef.current && tableRef.current.table) {
        const rows = tableRef.current.table.getRows();
        rows.forEach(row => {
          if (row.reformat) {
            row.reformat();
          }
        });

        // Restaurar scroll após atualização
        setTimeout(() => restaurarPosicaoScroll(), 100);
      }
    } catch (error) {
      toast.error('Não foi possível atualizar a solicitação.');
    }
  }, [carregarSolicitacoes, salvarPosicaoScroll, restaurarPosicaoScroll]);

  const verificarAprovacoesAutomaticas = useCallback(() => {
    const agora = new Date();
    const solicitacoesPendentes = solicitacoesRef.current.filter(s => s.status === 'pendente');

    solicitacoesPendentes.forEach(solicitacao => {
      const dataSolicitacao = new Date(solicitacao.data_solicitacao);
      const diffHoras = (agora - dataSolicitacao) / (1000 * 60 * 60);

      if (diffHoras >= 24) {
        aprovarSolicitacao(solicitacao.id, true);
      }
    });
  }, [aprovarSolicitacao]);


  const carregarSummary = async (filtrosAplicados = {}) => {
    try {
      setCarregandoSummary(true);

      // Aplicar cabeçalho de autenticação antes da chamada
      aplicarCabecalhoAuthAxios();

      const params = {
        ...filtrosAplicados
      };

      // Limpar parâmetros vazios
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (value === '' || value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
          delete params[key];
        }
      });

      const config = {
        params,
        headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': '0' }
      };

      // Usar endpoint otimizado por padrão (mais rápido)
      const url = `${REQUEST_URL}/relatorio-vendas/summary?t=${Date.now()}`;
      const res = await axios.get(url, config);

      // Usar dados recebidos ou valores padrão
      if (res.data && res.data.statusCounts) {
        setSummaryData({
          totalInstituicoes: res.data.totalInstituicoes || 0,
          statusCounts: res.data.statusCounts || {
            'EM NEGOCIAÇÃO': 0,
            'FECHADOS': 0,
            'PERDIDO': 0,
            'CONTATO OK': 0,
            'SEM CONTATO': 0
          }
        });
      } else {
        setSummaryData({
          totalInstituicoes: 0,
          statusCounts: {
            'EM NEGOCIAÇÃO': 0,
            'FECHADOS': 0,
            'PERDIDO': 0,
            'CONTATO OK': 0,
            'SEM CONTATO': 0
          }
        });
      }

    } catch (err) {
      // Mostra "—" nos cartões em vez de zeros que pareceriam reais
      setSummaryData({
        erro: true,
        totalInstituicoes: 0,
        statusCounts: {
          'EM NEGOCIAÇÃO': 0,
          'FECHADOS': 0,
          'PERDIDO': 0,
          'CONTATO OK': 0,
          'SEM CONTATO': 0
        }
      });
    } finally {
      setCarregandoSummary(false);
    }
  };


  const carregarDados = async (pagina = 1, limit = registrosPorPagina, filtrosAplicados = {}, incluirResumo = false) => {
    try {
      setCarregando(true);
      if (requestControllerRef.current) {
        try { requestControllerRef.current.abort(); } catch (e) { }
      }
      requestControllerRef.current = new AbortController();

      const limitePagina = Math.min(limit, 200);

      const params = {
        page: pagina,
        limit: limitePagina,
        ...filtrosAplicados,
        includeSummary: incluirResumo ? 'page' : 'false'
      };

      Object.keys(params).forEach(key => {
        const value = params[key];
        if (value === '' || value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
          delete params[key];
        }
      });

      const config = {
        params,
        signal: requestControllerRef.current.signal,
        headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': '0' },
        timeout: 120000 // Timeout de 120 segundos para filtros complexos como categoriaStatus
      };

      const url = `${REQUEST_URL}/relatorio-vendas?t=${Date.now()}`;
      const res = await axios.get(url, config);

      setDados(res.data.data);
      setDadosOriginais(res.data.data);

      if (res.data.statusIndisponivel) {
        toast.warn('Não foi possível consultar o Bitrix agora: os status das turmas podem aparecer em branco. Atualize em instantes.', { autoClose: 8000 });
      }

      // Summary agora é carregado separadamente

      setPaginaAtual(res.data.pagination.page);
      setTotalRegistros(res.data.pagination.total);
      setTotalPaginas(res.data.pagination.totalPages);

      // Otimização: processamento mais eficiente dos grupos
      const mapaGrupos = new Map();
      const dataArray = res.data.data;

      // Usar forEach mais eficiente
      for (let i = 0; i < dataArray.length; i++) {
        const item = dataArray[i];
        const chave = String(item.id_curso_inst_representante || item.id_curso_inst || `${item.nomeintituicao}|${item.sigla_instituicao}|${item.nomecurso}|${item.nomecidade}`);

        if (!mapaGrupos.has(chave)) {
          mapaGrupos.set(chave, []);
        }
        mapaGrupos.get(chave).push(item);
      }

      // Otimização: ordenação mais eficiente com cache do ano
      mapaGrupos.forEach((registros) => {
        registros.sort((a, b) => {
          const anoA = parseInt(String(a.Ano_Form).split('/')[0], 10);
          const anoB = parseInt(String(b.Ano_Form).split('/')[0], 10);
          return anoA - anoB;
        });
      });

      setGruposHistoricos(mapaGrupos);
    } catch (err) {
      if (axios.isCancel && axios.isCancel(err)) return;
      const descricao = err.response && err.response.data && err.response.data.error_description;
      toast.error(descricao || 'Não foi possível carregar os dados.');
      setDados([]);
      setDadosOriginais([]);
      setGruposHistoricos(new Map());
    } finally {
      setCarregando(false);
      requestControllerRef.current = null;
    }
  };

  useEffect(() => {
    if (!usuarioLogado.id) return;
    if (!sessionStorage.getItem('token')) {
      toast.error('Erro de autenticação. Por favor, faça o login novamente.');
      setCarregando(false);
      return;
    }

    aplicarCabecalhoAuthAxios();

    const filtrosParaRequisicao = {
      buscaGlobal: debouncedBuscaGlobal,
      ...filtros
    };

    // Sempre que os filtros mudarem, carregamos a página 1 e o summary
    carregarDados(1, registrosPorPagina, filtrosParaRequisicao, false);
    carregarSummary(filtrosParaRequisicao);

    carregarSolicitacoes();

    const interval = setInterval(() => {
      verificarAprovacoesAutomaticas();
    }, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, [usuarioLogado, debouncedBuscaGlobal, filtros]);

  // Otimização: Debounce mais longo para reduzir requests desnecessários
  useEffect(() => {
    const t = setTimeout(() => setDebouncedBuscaGlobal(buscaGlobal), 500);
    return () => clearTimeout(t);
  }, [buscaGlobal]);


  const dadosFiltrados = useMemo(() => {
    return dados;
  }, [dados]);


  // CÓDIGO CORRIGIDO
const dadosAgrupadosOriginal = useMemo(() => {
  try {
    const grupos = new Map();

    dadosFiltrados.forEach(item => {
      const chaveGrupo = String(item.id_curso_inst);

      if (!grupos.has(chaveGrupo)) {
        grupos.set(chaveGrupo, {
          id: chaveGrupo,
          id_representante: item.id_curso_inst,
          nomeintituicao: item.nomeintituicao,
          sigla_instituicao: item.sigla_instituicao,
          nomecurso: item.nomecurso,
          nomecidade: item.nomecidade,
          siglaestado: item.siglaestado,
          timeline: {},
          _children: [],
          _childrenHistorico: [],
          _childrenHistoricoCompleto: [] // Histórico completo (sem filtro) para cálculo de status
        });
      }

      const grupo = grupos.get(chaveGrupo);

      // Vínculo do curso calculado no servidor (mesma regra do filtro e dos contadores)
      if (typeof item.grupo_vinculado === 'boolean') {
        grupo.grupoVinculadoServidor = grupo.grupoVinculadoServidor || item.grupo_vinculado;
      }

      const anoSemestreItem = String(item.ano || item.Ano_Form);
      const chaveUnicaItem = `${item.id_curso_inst}-${anoSemestreItem}`;

      // Adicionar ao histórico completo (sempre, sem filtro)
      const temBitrix = (reg) =>
        reg && reg.idNegocioBitrix != null &&
        reg.idNegocioBitrix !== '' &&
        reg.idNegocioBitrix !== 'null' &&
        String(reg.idNegocioBitrix).trim() !== '' &&
        String(reg.idNegocioBitrix).trim() !== '0';

      const indiceHistoricoCompleto = grupo._childrenHistoricoCompleto.findIndex(existing => {
        const anoSemestreExisting = String(existing.ano || existing.Ano_Form);
        const chaveUnicaExisting = `${existing.id_curso_inst}-${anoSemestreExisting}`;
        return chaveUnicaExisting === chaveUnicaItem;
      });

      if (indiceHistoricoCompleto === -1) {
        grupo._childrenHistoricoCompleto.push(item);
      } else {
        // Já existe registro para este ano/semestre: dar preferência ao que
        // tem negócio no Bitrix (dono do lead), para que a linha principal
        // mostre o vendedor correto. Caso contrário, manter o existente.
        const existente = grupo._childrenHistoricoCompleto[indiceHistoricoCompleto];
        if (!temBitrix(existente) && temBitrix(item)) {
          grupo._childrenHistoricoCompleto[indiceHistoricoCompleto] = item;
        }
      }

      // CORREÇÃO: Verificar se o filtro de anos está ativo para o histórico filtrado
      let deveIncluirNoHistorico = true;
      if (filtros.anos && filtros.anos.length > 0) {
        // Se o filtro de anos está ativo, incluir apenas os anos filtrados
        deveIncluirNoHistorico = filtros.anos.includes(anoSemestreItem);
      }

      const jaExisteHistorico = grupo._childrenHistorico.some(existing => {
        const anoSemestreExisting = String(existing.ano || existing.Ano_Form);
        const chaveUnicaExisting = `${existing.id_curso_inst}-${anoSemestreExisting}`;
        return chaveUnicaExisting === chaveUnicaItem;
      });

      if (!jaExisteHistorico && deveIncluirNoHistorico) {
        grupo._childrenHistorico.push(item);
      }

      let ano = parseInt(String(item.ano || item.Ano_Form).split('/')[0], 10);
      if (!isNaN(ano) && ano >= 2025) {
        const jaExisteChildren = grupo._children.some(existing => {
          const anoSemestreExisting = String(existing.ano || existing.Ano_Form);
          const chaveUnicaExisting = `${existing.id_curso_inst}-${anoSemestreExisting}`;
          return chaveUnicaExisting === chaveUnicaItem;
        });

        if (!jaExisteChildren) {
          grupo._children.push(item);
        }
      }
    });

    grupos.forEach(grupo => {
      const mapaAnos = new Map();

      grupo._children.forEach(child => {
        const anoSemestre = String(child.ano || child.Ano_Form);
        if (!mapaAnos.has(anoSemestre)) {
          mapaAnos.set(anoSemestre, child);
        }
      });

      // Base das linhas vazias. Sem turma de 2025+ a base é o próprio grupo, e os campos
      // da árvore (_children, id...) não podem ir para as turmas: viraria linha de grupo.
      const {
        _children: _filhos, _childrenHistorico: _hist, _childrenHistoricoCompleto: _histCompleto,
        timeline: _timeline, id: _idGrupo, grupoVinculadoServidor: _vinculo, ...dadosBase
      } = grupo._children[0] || grupo;

      // Turma sem registro no banco: linha só de exibição. Não copia negócio, prazo
      // estendido nem vendedor da turma usada como base (dadosBase).
      const criarTurmaVazia = (anoSemestreKey) => ({
        ...dadosBase,
        _placeholder: true,
        Ano_Form: anoSemestreKey,
        ano: anoSemestreKey,
        ano_formatura: anoSemestreKey,
        CategoriaStatus: null,
        Status: null,
        idNegocioBitrix: null,
        range_end_date: null,
        data_inclusao_orcamento: null,
        vendedor_id: null,
        vendedor: null,
        vendedor_exibicao: null,
        nome_vendedor: null,
        id_curso_inst: dadosBase.id_curso_inst || grupo.id_representante,
        cod_inst: dadosBase.cod_inst || grupo.cod_inst,
        cod_curso: dadosBase.cod_curso || grupo.cod_curso,
        cod_cidade: dadosBase.cod_cidade || grupo.cod_cidade
      });

      if (filtros.anos && filtros.anos.length > 0) {
        // Com filtro de anos, linhas vazias só para os anos filtrados
        filtros.anos.forEach(anoSemestreKey => {
          if (!mapaAnos.has(anoSemestreKey)) {
            mapaAnos.set(anoSemestreKey, criarTurmaVazia(anoSemestreKey));
          }
        });
      } else {
        // Sem filtro, linhas para todos os semestres de 2025 a 2030
        for (let ano = 2025; ano <= 2030; ano++) {
          for (let semestre = 1; semestre <= 2; semestre++) {
            const anoSemestreKey = `${ano}/${semestre}`;
            if (!mapaAnos.has(anoSemestreKey)) {
              mapaAnos.set(anoSemestreKey, criarTurmaVazia(anoSemestreKey));
            }
          }
        }
      }

      grupo._children = Array.from(mapaAnos.values());

      grupo._children.sort((a, b) => {
        const anoA = parseInt(String(a.ano || a.Ano_Form).split('/')[0], 10);
        const anoB = parseInt(String(b.ano || b.Ano_Form).split('/')[0], 10);
        if (anoA !== anoB) return anoA - anoB;

        const semestreA = parseInt(String(a.ano || a.Ano_Form).split('/')[1], 10) || 1;
        const semestreB = parseInt(String(b.ano || b.Ano_Form).split('/')[1], 10) || 1;
        return semestreA - semestreB;
      });
      
    // Ordena do mais recente para o mais antigo (ano e depois semestre).
    const ordenarMaisRecentePrimeiro = (a, b) => {
      const anoA = parseInt(String(a.ano || a.Ano_Form).split('/')[0], 10);
      const anoB = parseInt(String(b.ano || b.Ano_Form).split('/')[0], 10);
      if (anoB !== anoA) return anoB - anoA; // Ano mais recente primeiro

      // Desempate por semestre: semestre mais recente primeiro
      const semestreA = parseInt(String(a.ano || a.Ano_Form).split('/')[1], 10) || 1;
      const semestreB = parseInt(String(b.ano || b.Ano_Form).split('/')[1], 10) || 1;
      return semestreB - semestreA;
    };

    const temVendedorValido = (filho) =>
      filho.vendedor_id != null &&
      filho.vendedor_id !== 'null' &&
      String(filho.vendedor_id).trim() !== '';

    const eAnoRelevante = (filho) => {
      const anoRegistro = parseInt(String(filho.ano || filho.Ano_Form).split('/')[0], 10);
      return !isNaN(anoRegistro) && anoRegistro >= 2025;
    };

    const temNegocioBitrix = (filho) =>
      filho.idNegocioBitrix != null &&
      filho.idNegocioBitrix !== '' &&
      filho.idNegocioBitrix !== 'null' &&
      String(filho.idNegocioBitrix).trim() !== '' &&
      String(filho.idNegocioBitrix).trim() !== '0';

    // Prioridade 1: vendedor do DONO DO LEAD no Bitrix — registro mais recente
    // (ano+semestre) que possua idNegocioBitrix e vendedor válido. É o vendedor
    // que deve aparecer na linha principal.
    const registroLeadBitrix = [...grupo._childrenHistoricoCompleto]
      .filter(filho => temVendedorValido(filho) && eAnoRelevante(filho) && temNegocioBitrix(filho))
      .sort(ordenarMaisRecentePrimeiro)[0];

    // Prioridade 2 (fallback): mais recente com vendedor válido, mesmo sem lead.
    const registroMaisRecenteComVendedor = registroLeadBitrix || [...grupo._childrenHistoricoCompleto]
      .filter(filho => temVendedorValido(filho) && eAnoRelevante(filho))
      .sort(ordenarMaisRecentePrimeiro)[0];

    // Se encontrou um registro, define o vendedor e o nome do vendedor para o grupo (a linha principal).
    if (registroMaisRecenteComVendedor) {
      grupo.vendedor_id = registroMaisRecenteComVendedor.vendedor_id;
      grupo.nome_vendedor = registroMaisRecenteComVendedor.nome_vendedor;
    }

      // Ordenar histórico filtrado (para exibição)
      grupo._childrenHistorico.sort((a, b) => {
        const anoA = parseInt(String(a.ano || a.Ano_Form).split('/')[0], 10);
        const anoB = parseInt(String(b.ano || b.Ano_Form).split('/')[0], 10);
        return anoA - anoB;
      });

      // Ordenar histórico completo
      grupo._childrenHistoricoCompleto.sort((a, b) => {
        const anoA = parseInt(String(a.ano || a.Ano_Form).split('/')[0], 10);
        const anoB = parseInt(String(b.ano || b.Ano_Form).split('/')[0], 10);
        return anoA - anoB;
      });

      const anoAtual = new Date().getFullYear();
      // Usar histórico COMPLETO para cálculo de tempo de validade
      if (grupo._childrenHistoricoCompleto.length > 0) {
        const historicoOrdenado = [...grupo._childrenHistoricoCompleto].sort((a, b) => {
          const anoA = parseInt(String(a.ano || a.Ano_Form).split('/')[0], 10);
          const anoB = parseInt(String(b.ano || b.Ano_Form).split('/')[0], 10);
          return anoB - anoA;
        });

        const registroMaisRecente = historicoOrdenado.find(item => item.CategoriaStatus);
        if (registroMaisRecente) {
          const anoRegistro = parseInt(String(registroMaisRecente.ano || registroMaisRecente.Ano_Form).split('/')[0], 10);
          let duracao = 1;
          switch (registroMaisRecente.CategoriaStatus) {
            case 'EM NEGOCIAÇÃO': duracao = 2; break;
            case 'FECHADOS': duracao = 4; break;
          }
          const anoFimValidade = anoRegistro + duracao;
          const anosRestantes = anoFimValidade - anoAtual;
          if (anosRestantes > 0) {
            grupo.tempoValidade = `${anosRestantes} ano${anosRestantes > 1 ? 's' : ''}`;
          } else {
            grupo.tempoValidade = 'Expirado';
          }
        } else {
          grupo.tempoValidade = 'N/A';
        }
      } else {
        grupo.tempoValidade = 'N/A';
      }

      const anosComRegistroTimeLine = new Set();
      grupo._children.forEach(filho => {
        if (filho.Status || filho.CategoriaStatus) {
          const anoFilho = parseInt(String(filho.ano || filho.Ano_Form).split('/')[0], 10);
          anosComRegistroTimeLine.add(anoFilho);

          let dataUltimoCadastro = 'N/A';
          if (filho.data_inclusao_orcamento) {
            try {
              const data = new Date(filho.data_inclusao_orcamento);
              dataUltimoCadastro = data.toLocaleDateString('pt-BR');
            } catch (e) {
              dataUltimoCadastro = filho.data_inclusao_orcamento;
            }
          }

          const statusParaTimeline = filho.CategoriaStatus || filho.Status;
          const anoCompleto = String(filho.ano || filho.Ano_Form);
          const semestre = anoCompleto.split('/')[1];

          // Um chip por ano, com uma metade por semestre: 2027/1 e 2027/2 não se sobrepõem
          if (!grupo.timeline[anoFilho]) grupo.timeline[anoFilho] = { itens: [] };
          grupo.timeline[anoFilho].itens.push({
            semestre: semestre === '1' || semestre === '2' ? semestre : null,
            status: statusParaTimeline,
            cor: categoriaStatusCores[statusParaTimeline] || '#6c757d',
            vendedor: filho.nome_vendedor,
            turno: filho.Turno_Form,
            anoCompleto,
            dataUltimoCadastro: dataUltimoCadastro
          });
        }
      });

      const temRegistroRecenteOuFuturo = Array.from(anosComRegistroTimeLine).some(ano => ano >= anoAtual - 2);
      // Usar histórico COMPLETO para cálculo do statusGrupo
      const temStatusValidoRecente = grupo._childrenHistoricoCompleto.some(item => {
        const anoItem = parseInt(String(item.ano || item.Ano_Form).split('/')[0], 10);
        return anoItem >= anoAtual - 2 && (
          (item.CategoriaStatus && item.CategoriaStatus !== '' && item.CategoriaStatus !== 'null' && item.CategoriaStatus !== null) ||
          (item.idNegocioBitrix && item.idNegocioBitrix !== '' && item.idNegocioBitrix !== 'null' && item.idNegocioBitrix !== null)
        );
      });

      // O servidor calcula o vínculo com todas as turmas do curso (mesma regra do filtro
      // Livre/Vinculado e dos contadores). O cálculo local fica só de reserva.
      const vinculadoLocal = temRegistroRecenteOuFuturo && temStatusValidoRecente;
      const vinculado = typeof grupo.grupoVinculadoServidor === 'boolean' ? grupo.grupoVinculadoServidor : vinculadoLocal;
      grupo.statusGrupo = vinculado ? STATUS_GRUPO.VINCULADO : STATUS_GRUPO.LIVRE;

      // Usar histórico COMPLETO para cálculo de contatos
      const anosComContatoItens = grupo._childrenHistoricoCompleto.filter(item =>
        item.CategoriaStatus && item.vendedor_id && item.vendedor_id !== 'null'
      );
      
      let statusGeralAnos = null;
      if (anosComContatoItens.length > 0) {
        const contagemPorVendedor = anosComContatoItens.reduce((acc, item) => {
          acc[item.vendedor_id] = (acc[item.vendedor_id] || 0) + 1;
          return acc;
        }, {});
        const algumVendedorRegional = Object.values(contagemPorVendedor).some(count => count >= 2);
        if (algumVendedorRegional) {
          statusGeralAnos = 'REGIONAL';
        } else {
          statusGeralAnos = 'HISTORICO';
        }
      }
    });

    let gruposFiltrados = Array.from(grupos.values()).filter(grupo => grupo._children.length > 0);

    if (filtros.statusGrupo && filtros.statusGrupo.length > 0) {
      gruposFiltrados = gruposFiltrados.filter(grupo => {
        // grupo.statusGrupo é um objeto {id, descricao}
        const statusDescricao = (grupo.statusGrupo && grupo.statusGrupo.descricao) || '';
        return filtros.statusGrupo.includes(statusDescricao);
      });
    }

    if (filtros.categoriaStatus && filtros.categoriaStatus.length > 0) {
      gruposFiltrados.forEach(grupo => {
        grupo._children = grupo._children.filter(child => {
          const ano = parseInt(String(child.ano || child.Ano_Form).split('/')[0], 10);
          const eAnoTimeline = !isNaN(ano) && ano >= 2025;
          const temCategoriaCorreta = child.CategoriaStatus && filtros.categoriaStatus.includes(child.CategoriaStatus);

          return temCategoriaCorreta && eAnoTimeline;
        });
      });
    }

    return gruposFiltrados;

  } catch (error) {
    return [];
  }
}, [dadosFiltrados, filtros.statusGrupo, filtros.anos]);


  const dadosAgrupados = dadosAgrupadosOriginal;

  // Summary sempre usa dados originais do backend
  const summaryFiltrado = summaryData;

  const mudarPagina = (novaPagina) => {
    if (novaPagina < 1 || novaPagina > totalPaginas || novaPagina === paginaAtual || carregando || atualizando) {
      return;
    }

    // Cancelar requests pendentes para evitar conflitos
    if (requestControllerRef.current) {
      try {
        requestControllerRef.current.abort();
      } catch (e) {
        // Ignorar erro ao cancelar
      }
    }

    const filtrosParaRequisicao = {
      buscaGlobal: debouncedBuscaGlobal,
      ...filtros
    };

    carregarDados(novaPagina, registrosPorPagina, filtrosParaRequisicao, false);

    carregarSummary(filtrosParaRequisicao);
  };

  const getExpandedGroupIds = useCallback(() => {
    const table = tableRef.current && tableRef.current.table;
    if (!table) return new Set();
    const rows = table.getRows();
    const ids = rows
      .filter(r => {
        const d = r.getData && r.getData();
        return d && d._children && r.isTreeExpanded && r.isTreeExpanded();
      })
      .map(r => {
        const d = r.getData && r.getData();
        return d ? d.id : undefined;
      })
      .filter(Boolean);
    return new Set(ids);
  }, []);

  function reexpandGroups(table, expandedSet) {
    if (!table || !expandedSet || expandedSet.size === 0) return;
    const rows = table.getRows();
    expandedSet.forEach(id => {
      const row = rows.find(r => {
        const d = r.getData && r.getData();
        return d && d.id === id;
      });
      if (row && row.isTreeExpanded && !row.isTreeExpanded()) {
        if (row.treeExpand) row.treeExpand();
      }
    });
  }

  const aoAlterarVendedor = useCallback((idLinha, idNovoVendedor, ano) => {
    if (!idLinha) {
      toast.error('Erro: ID da linha não encontrado.');
      return;
    }
    // Salvar scroll e grupos expandidos antes de atualizar
    salvarPosicaoScroll();
    const gruposExpandidosAntes = getExpandedGroupIds();
    setAtualizando(true);
    axios.put(`${REQUEST_URL}/relatorio-vendas/vendedor`, {
      id_curso_inst: idLinha,
      vendedorId: idNovoVendedor,
      vendedorNome: getNomeVendedor(idNovoVendedor),
      ano: ano
    })
      .then(() => {
        toast.success('Vendedor alterado com sucesso!');

        const table = tableRef.current && tableRef.current.table;

        setDados(prevDados => {
          return prevDados.map(item => {
            if (String(item.id_curso_inst) === String(idLinha) && String(item.Ano_Form) === String(ano)) {
              return {
                ...item,
                vendedor_id: idNovoVendedor,
                nome_vendedor: getNomeVendedor(idNovoVendedor),
              };
            }
            return item;
          });
        });

        if (table) {
          const linhaParaAtualizar = table.getRow(idLinha);
          if (linhaParaAtualizar) {
            const rowData = linhaParaAtualizar.getData();
            if (rowData._children) {
              // Atualizar os filhos correspondentes
              rowData._children = rowData._children.map(child => {
                if (String(child.Ano_Form) === String(ano)) {
                  return {
                    ...child,
                    vendedor_id: idNovoVendedor,
                    nome_vendedor: getNomeVendedor(idNovoVendedor)
                  };
                }
                return child;
              });
              linhaParaAtualizar.update(rowData);
            }
          }
        }

        setGruposExpandidos(gruposExpandidosAntes);
        const tableNow = tableRef.current && tableRef.current.table;
        setTimeout(() => {
          reexpandGroups(tableNow, gruposExpandidosAntes);
          // Restaurar scroll após re-expandir
          restaurarPosicaoScroll();
        }, 50);
      })
      .catch(err => {
        toast.error('Não foi possível alterar o vendedor.');
      })
      .finally(() => {
        setAtualizando(false);
      });
  }, [vendedores, getExpandedGroupIds, getNomeVendedor, salvarPosicaoScroll, restaurarPosicaoScroll]);

  const aoRelacionarVendedorGrupo = useCallback((grupoId, idNovoVendedor) => {
    // Salvar scroll e grupos expandidos antes de atualizar
    salvarPosicaoScroll();
    setAtualizando(true);
    const gruposExpandidosAntes = getExpandedGroupIds();
    const grupo = dadosAgrupados.find(g => g.id === grupoId);
    if (!grupo || !grupo._children || grupo._children.length === 0) {
      toast.error('Erro: Grupo não encontrado ou sem itens.');
      setAtualizando(false);
      return;
    }
    const atualizacoes = grupo._children.map(item => ({
      id_curso_inst: item.id_curso_inst,
      vendedorId: ((item.Status && item.Status !== '' && item.Status !== null) || (item.CategoriaStatus && item.CategoriaStatus !== '' && item.CategoriaStatus !== null)) ? item.vendedor_id : idNovoVendedor,
      ano: item.Ano_Form
    }));
    Promise.all(atualizacoes.map(update =>
      axios.put(`${REQUEST_URL}/relatorio-vendas/vendedor`, update)
    ))
      .then(() => {
        const vendedorNome = getNomeVendedor(idNovoVendedor) || 'Nenhum';
        toast.success(`Vendedor ${vendedorNome} atribuído ao grupo!`);
        const table = tableRef.current && tableRef.current.table;

        // Preparar dados atualizados ANTES de usar no setState
        const dadosParaAtualizar = grupo._children.map(item => {
          const manterVendedor = (item.Status && item.Status !== '' && item.Status !== null) || (item.CategoriaStatus && item.CategoriaStatus !== '' && item.CategoriaStatus !== null);
          const vendedorIdFinal = manterVendedor ? item.vendedor_id : idNovoVendedor;
          return {
            ...item,
            vendedor_id: vendedorIdFinal,
            nome_vendedor: getNomeVendedor(vendedorIdFinal),
          };
        });
        const dadosAtualizadosMap = new Map(dadosParaAtualizar.map(d => [`${d.id_curso_inst}|${d.Ano_Form}`, d]));

        setDados(prevDados => {
          return prevDados.map(item => {
            const key = `${item.id_curso_inst}|${item.Ano_Form}`;
            if (dadosAtualizadosMap.has(key)) {
              return dadosAtualizadosMap.get(key);
            }
            return item;
          });
        });

        if (table) {
          const linhaGrupo = table.getRow(grupoId);
          if (linhaGrupo) {
            const rowData = linhaGrupo.getData();
            if (rowData._children) {
              rowData._children = rowData._children.map(child => {
                const key = `${child.id_curso_inst}|${child.Ano_Form}`;
                if (dadosAtualizadosMap.has(key)) {
                  return dadosAtualizadosMap.get(key);
                }
                return child;
              });
              // Atualizar vendedor do grupo também
              rowData.vendedor_id = idNovoVendedor;
              rowData.nome_vendedor = getNomeVendedor(idNovoVendedor);
              linhaGrupo.update(rowData);
            }
          }
        }

        setGruposExpandidos(gruposExpandidosAntes);
        const tableNow = tableRef.current && tableRef.current.table;
        setTimeout(() => {
          reexpandGroups(tableNow, gruposExpandidosAntes);
          // Restaurar scroll após re-expandir
          restaurarPosicaoScroll();
        }, 50);
      })
      .catch(err => {
        toast.error('Não foi possível atualizar o vendedor do grupo.');
      })
      .finally(() => {
        setAtualizando(false);
      });
  }, [dadosAgrupados, getExpandedGroupIds, getNomeVendedor, salvarPosicaoScroll, restaurarPosicaoScroll]);

  const criarMenuFiltroColuna = useCallback((campo, opcoes, tipo = 'input') => {
    return (cell, onRendered, success, cancel, editorParams) => {
      const container = document.createElement("div");
      container.className = "column-filter-menu";

      let searchInput;

      if (tipo === 'input') {
        searchInput = document.createElement("input");
        searchInput.className = "column-filter-search";
        searchInput.placeholder = "Buscar...";
        searchInput.value = filtrosColuna[campo] || '';

        searchInput.addEventListener("input", (e) => {
          setFiltrosColuna(prev => ({
            ...prev,
            [campo]: e.target.value
          }));
        });

        container.appendChild(searchInput);
      } else {
        searchInput = document.createElement("input");
        searchInput.className = "column-filter-search";
        searchInput.placeholder = "Buscar...";

        const optionsContainer = document.createElement("div");
        optionsContainer.style.maxHeight = "200px";
        optionsContainer.style.overflowY = "auto";

        const updateOptions = (searchTerm = '') => {
          optionsContainer.innerHTML = '';
          const filteredOptions = opcoes.filter(option =>
            option.toLowerCase().includes(searchTerm.toLowerCase())
          );

          filteredOptions.forEach(option => {
            const optionDiv = document.createElement("div");
            optionDiv.className = "column-filter-option";

            const checkbox = document.createElement("input");
            checkbox.type = "checkbox";
            checkbox.checked = (filtros[campo] && filtros[campo].includes(option)) || false;

            const label = document.createElement("span");
            label.textContent = option;

            optionDiv.appendChild(checkbox);
            optionDiv.appendChild(label);

            optionDiv.addEventListener("click", () => {
              checkbox.checked = !checkbox.checked;
              toggleFiltro(campo, option);
            });

            optionsContainer.appendChild(optionDiv);
          });
        };

        searchInput.addEventListener("input", (e) => {
          updateOptions(e.target.value);
        });

        updateOptions();

        container.appendChild(searchInput);
        container.appendChild(optionsContainer);
      }

      const actions = document.createElement("div");
      actions.className = "column-filter-actions";

      const clearBtn = document.createElement("button");
      clearBtn.className = "column-filter-btn-small clear";
      clearBtn.textContent = "Limpar";
      clearBtn.addEventListener("click", () => {
        setFiltrosColuna(prev => {
          const newFilters = { ...prev };
          delete newFilters[campo];
          return newFilters;
        });
        success();
      });

      const applyBtn = document.createElement("button");
      applyBtn.className = "column-filter-btn-small apply";
      applyBtn.textContent = "Aplicar";
      applyBtn.addEventListener("click", () => {
        success();
      });

      actions.appendChild(clearBtn);
      actions.appendChild(applyBtn);
      container.appendChild(actions);

      onRendered(() => {
        if (tipo === 'input' && searchInput) {
          searchInput.focus();
        }
      });

      return container;
    };
  }, [filtros, filtrosColuna, toggleFiltro]);

  const timelineFormatter = (cell) => {
    const rowData = cell.getRow().getData();

    if (rowData._children) {
      const timelineHtml = [];
      const anoAtual = new Date().getFullYear();
      const anoInicio = 2025;
      const anoFim = 2030;
      const corVazia = '#f3f4f6';

      for (let ano = anoInicio; ano <= anoFim; ano++) {
        const dadosAno = rowData.timeline && rowData.timeline[ano];
        const itens = (dadosAno && dadosAno.itens) || [];
        const eAnoAtual = (ano === anoAtual);

        let fundo = corVazia;
        let tooltip = `${ano} - Sem dados`;
        const textoAno = ano.toString();

        if (itens.length > 0) {
          // Metade esquerda = 1º semestre, direita = 2º. Turma sem semestre pinta o chip todo.
          const doSemestre = (sem) => itens.find(i => i.semestre === sem);
          const semSemestre = itens.find(i => !i.semestre);
          if (semSemestre && !doSemestre('1') && !doSemestre('2')) {
            fundo = semSemestre.cor;
          } else {
            const cor1 = (doSemestre('1') || {}).cor || corVazia;
            const cor2 = (doSemestre('2') || {}).cor || corVazia;
            fundo = cor1 === cor2 ? cor1 : `linear-gradient(90deg, ${cor1} 50%, ${cor2} 50%)`;
          }
          tooltip = itens
            .slice()
            .sort((a, b) => String(a.anoCompleto).localeCompare(String(b.anoCompleto)))
            .map(i => `Turma: ${i.anoCompleto}<br>Status: ${i.status}<br>Vendedor: ${i.vendedor || 'A definir'}<br>Data de Inclusão: ${i.dataUltimoCadastro}`)
            .join('<br><br>');
        }

        timelineHtml.push(`
          <div class="timeline-year ${itens.length > 0 ? 'has-data' : ''} ${eAnoAtual ? 'current' : ''}"
               style="background: ${fundo}; ${itens.length > 0 ? 'text-shadow: 0 0 2px rgba(0,0,0,0.7);' : ''}"
               data-ano="${ano}"
               data-tooltip="${tooltip.replace(/"/g, '&quot;')}">
            ${textoAno}
          </div>
        `);
      }

      return `
        <div class="timeline-visual" data-grupo-id="${rowData.id}">
          ${timelineHtml.join('')}
        </div>
      `;
    }

    return '';
  };

  const posicionarTooltip = (elemento, tooltip) => {
    const rect = elemento.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    const espacoTopo = rect.top;
    const espacoBase = window.innerHeight - rect.bottom;
    const espacoEsquerda = rect.left;
    const espacoDireita = window.innerWidth - rect.right;

    let posicao = 'bottom';
    let top, left;

    if (espacoBase >= tooltipRect.height + 20) {
      posicao = 'bottom';
      top = rect.bottom + 10;
      left = rect.left + (rect.width / 2) - (tooltipRect.width / 2);
    }
    else if (espacoTopo >= tooltipRect.height + 20) {
      posicao = 'top';
      top = rect.top - tooltipRect.height - 10;
      left = rect.left + (rect.width / 2) - (tooltipRect.width / 2);
    }
    else if (espacoDireita >= tooltipRect.width + 20) {
      posicao = 'right';
      top = rect.top + (rect.height / 2) - (tooltipRect.height / 2);
      left = rect.right + 10;
    }
    else if (espacoEsquerda >= tooltipRect.width + 20) {
      posicao = 'left';
      top = rect.top + (rect.height / 2) - (tooltipRect.height / 2);
      left = rect.left - tooltipRect.width - 10;
    }
    else {
      top = (window.innerHeight - tooltipRect.height) / 2;
      left = (window.innerWidth - tooltipRect.width) / 2;
    }

    if (left < 10) left = 10;
    if (left + tooltipRect.width > window.innerWidth - 10) {
      left = window.innerWidth - tooltipRect.width - 10;
    }
    if (top < 10) top = 10;
    if (top + tooltipRect.height > window.innerHeight - 10) {
      top = window.innerHeight - tooltipRect.height - 10;
    }

    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;
    tooltip.className = `timeline-tooltip-container ${posicao}`;
  };

  useEffect(() => {
    let tooltipContainer = null;
    let activeElement = null;
    let timeoutId = null;

    const handleTimelineHover = (e) => {
      if (e.target.classList.contains('timeline-year')) {
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }

        if (tooltipContainer && tooltipContainer.parentNode) {
          tooltipContainer.parentNode.removeChild(tooltipContainer);
          tooltipContainer = null;
          activeElement = null;
        }

        tooltipContainer = document.createElement('div');
        tooltipContainer.className = 'timeline-tooltip-container';
        tooltipContainer.style.opacity = '0';

        const tooltipText = e.target.getAttribute('data-tooltip');
        if (tooltipText) {
          tooltipContainer.innerHTML = tooltipText.replace(/&quot;/g, '"').replace(/<br>/g, '<br/>');
        }

        document.body.appendChild(tooltipContainer);

        tooltipContainer.style.opacity = '0';

        posicionarTooltip(e.target, tooltipContainer);

        requestAnimationFrame(() => {
          if (tooltipContainer) {
            tooltipContainer.style.opacity = '1';
          }
        });

        activeElement = e.target;
      }
    };

    const handleTimelineLeave = (e) => {
      if (e.target.classList.contains('timeline-year') && activeElement === e.target) {
        timeoutId = setTimeout(() => {
          if (tooltipContainer && tooltipContainer.parentNode) {
            tooltipContainer.style.opacity = '0';
            setTimeout(() => {
              if (tooltipContainer && tooltipContainer.parentNode) {
                tooltipContainer.parentNode.removeChild(tooltipContainer);
              }
              tooltipContainer = null;
              activeElement = null;
            }, 200);
          }
        }, 100);
      }
    };

    // Gerenciar tooltips dos cabeçalhos
    let headerTooltip = null;

    const handleHeaderHover = (e) => {
      if (e.target.classList.contains('column-header-tooltip')) {
        if (headerTooltip) {
          headerTooltip.remove();
          headerTooltip = null;
        }

        const tooltipText = e.target.getAttribute('data-tooltip');
        if (tooltipText) {
          headerTooltip = document.createElement('div');
          headerTooltip.className = 'header-tooltip';
          headerTooltip.textContent = tooltipText;
          document.body.appendChild(headerTooltip);

          // Posicionar a tooltip
          const rect = e.target.getBoundingClientRect();
          const tooltipRect = headerTooltip.getBoundingClientRect();

          let top = rect.top - tooltipRect.height - 10;
          let left = rect.left + (rect.width / 2);

          // Ajustar se sair da tela
          if (top < 0) {
            top = rect.bottom + 10;
          }
          if (left < 0) {
            left = 10;
          }
          if (left + tooltipRect.width > window.innerWidth) {
            left = window.innerWidth - tooltipRect.width - 10;
          }

          headerTooltip.style.top = `${top}px`;
          headerTooltip.style.left = `${left}px`;

          // Mostrar com animação
          setTimeout(() => {
            if (headerTooltip) {
              headerTooltip.classList.add('show');
            }
          }, 10);
        }
      }
    };

    const handleHeaderLeave = (e) => {
      if (e.target.classList.contains('column-header-tooltip')) {
        if (headerTooltip) {
          headerTooltip.classList.remove('show');
          setTimeout(() => {
            if (headerTooltip) {
              headerTooltip.remove();
              headerTooltip = null;
            }
          }, 300);
        }
      }
    };

    document.addEventListener('mouseover', handleTimelineHover);
    document.addEventListener('mouseout', handleTimelineLeave);
    document.addEventListener('mouseover', handleHeaderHover);
    document.addEventListener('mouseout', handleHeaderLeave);

    return () => {
      document.removeEventListener('mouseover', handleTimelineHover);
      document.removeEventListener('mouseout', handleTimelineLeave);
      document.removeEventListener('mouseover', handleHeaderHover);
      document.removeEventListener('mouseout', handleHeaderLeave);

      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (tooltipContainer && tooltipContainer.parentNode) {
        tooltipContainer.parentNode.removeChild(tooltipContainer);
      }
      if (headerTooltip) {
        headerTooltip.remove();
      }
    };
  }, []);

  useEffect(() => {
    // Grupos históricos atualizados
  }, [gruposHistoricos]);

  // NOVO: Listener para salvar scroll automaticamente quando o usuário rola
  useEffect(() => {
    const table = tableRef.current && tableRef.current.table;
    if (!table || !table.element) return;

    const tableHolder = table.element.querySelector('.tabulator-tableholder');
    if (!tableHolder) return;

    // Debounced scroll handler para não salvar a cada pixel
    let scrollTimeout;
    const handleScroll = () => {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        salvarPosicaoScroll();
      }, 150);
    };

    tableHolder.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      tableHolder.removeEventListener('scroll', handleScroll);
    };
  }, [salvarPosicaoScroll]);


  const getHistoricoCompletoGrupo = useCallback((grupoId) => {
    const historicoCompleto = gruposHistoricos.get(String(grupoId)) || [];

    // Filtrar apenas registros que tenham status definido (histórico real) e sejam de 2024 para baixo
    const historicoFiltrado = historicoCompleto.filter(item => {
      const ano = parseInt(String(item.Ano_Form).split('/')[0], 10);

      // Verificar se tem status válido (não nulo, não vazio, não "SEM STATUS")
      const temStatusValido = (item.Status &&
        item.Status.trim() !== '' &&
        item.Status !== 'SEM STATUS') ||
        (item.CategoriaStatus &&
          item.CategoriaStatus.trim() !== '' &&
          item.CategoriaStatus !== 'SEM STATUS');

      // Filtrar apenas anos de 2024 para baixo
      return temStatusValido && !isNaN(ano) && ano <= 2024;
    });

    const historicoUnico = [];
    const chavesProcessadas = new Set();

    historicoFiltrado.forEach(item => {
      // Criar chave única: id_curso_inst + ano + semestre
      const chaveUnica = `${item.id_curso_inst}-${String(item.Ano_Form)}`;

      if (!chavesProcessadas.has(chaveUnica)) {
        historicoUnico.push(item);
        chavesProcessadas.add(chaveUnica);
      } else {
        // Se já existe, manter o registro mais completo (com status mais recente)
        const indexExistente = historicoUnico.findIndex(existing => {
          return `${existing.id_curso_inst}-${String(existing.Ano_Form)}` === chaveUnica;
        });

        if (indexExistente !== -1) {
          const existente = historicoUnico[indexExistente];
          // Substituir se o novo item tem dados mais completos
          if (item.CategoriaStatus && (!existente.CategoriaStatus ||
            (item.vendedor_id && item.vendedor_id !== 'null' && item.vendedor_id !== null))) {
            historicoUnico[indexExistente] = item;
          }
        }
      }
    });

    return historicoUnico;
  }, [gruposHistoricos]);

  const vendedorFormatter = (cell) => {
    const rowData = cell.getRow().getData();

    if (rowData._children) {
      const vendedorNome = getNomeVendedor(rowData.vendedor_id, rowData.nome_vendedor);
      return `<div class="vendedor-name-cell" title="${vendedorNome}">${vendedorNome}</div>`;
    }

    let eHistorico = false;
    if (typeof rowData.Ano_Form === 'string' && rowData.Ano_Form.includes('/')) {
      eHistorico = true;
    } else {
      const ano = parseInt(rowData.Ano_Form, 10);
      eHistorico = !isNaN(ano) && ano < 2025;
    }

    if (eHistorico) {
      const vendedorNome = getNomeVendedor(rowData.vendedor_id, rowData.nome_vendedor || rowData.vendedor);
      return `<div class="vendedor-name-cell" title="${vendedorNome}">${vendedorNome}</div>`;
    }

    const vendedorId = rowData.vendedor_id;
    const vendedorNome = getNomeVendedor(vendedorId, rowData.nome_vendedor || rowData.vendedor);

    return `
      <div class="vendedor-cell">
        <div class="vendedor-name-cell" title="${vendedorNome}">${vendedorNome}</div>
        <button class="vendedor-btn-cell">Selecionar</button>
      </div>
    `;
  };

  const relacionarVendedorFormatter = (cell) => {
    const rowData = cell.getRow().getData();
    if (rowData._children) {
      return `<button class="relacionar-vendedor-btn">Relacionar</button>`;
    }
    return '';
  };

  const customHeaderFormatter = (coluna, titulo) => {
    const temFiltroAtivo = filtrosColuna[coluna] && filtrosColuna[coluna].length > 0;
    return `
      <div class="header-with-filter">
        <span>${titulo}</span>
        <button class="filter-button ${temFiltroAtivo ? 'active' : ''}" data-coluna="${coluna}">
          <i class="fas fa-filter"></i>
        </button>
      </div>
    `;
  };

  const colunasTabela = useMemo(() => {
    // Colunas permitidas para usuários com permissão "ver"
    const colunasPermitidas = [
      'nomeintituicao',
      'statusGrupo',
      'historicoValido',
      'sigla_instituicao',
      'nomecurso',
      'nomecidade',
      'siglaestado',
      'vendedor_id',
      'range',
      'Ano_Form',
      'solicitacao',
      'orcamento'
    ];

    const todasColunas = [
      {
        title: "Instituição",
        field: 'nomeintituicao',
        headerSort: false,
        width: 320,
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Nome da instituição de ensino superior">Instituição</span>',
        formatter: (cell) => {
          const rowData = cell.getRow().getData();
          const instituicao = cell.getValue();
          if (rowData._children) {
            const grupoId = rowData.id;
            return `<div class="instituicao-com-historico" style="padding-left: 0; margin-left: 0;"><span class="instituicao-nome" title="${instituicao}">${instituicao}</span><button class="historico-icon-btn" data-grupo-id="${encodeURIComponent(grupoId)}" title="Consultar histórico completo">📅</button></div>`;
          }
          return `<span title="${instituicao}" style="padding-left: 0;">${instituicao}</span>`;
        },
        cellClick: (e, cell) => {
          if (e.target.classList.contains('historico-icon-btn')) {
            e.preventDefault(); e.stopPropagation();
            const grupoId = decodeURIComponent(e.target.getAttribute('data-grupo-id'));
            const historicoCompleto = getHistoricoCompletoGrupo(grupoId);
            setTimelineData({ ...cell.getRow().getData(), _childrenHistorico: historicoCompleto });
            setModalTimeline(true);
            return;
          }
          toggleGrupoInstituicao(e, cell);
        },
      },
      {
        title: "Status Range",
        field: "statusGrupo",
        width: 130,
        hozAlign: "center",
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Status Range: LIVRE (sem histórico recente) ou VINCULADO (com histórico nos últimos 2 anos)">Status Range</span>',
        headerSort: false,
        formatter: (cell) => {
          const rowData = cell.getRow().getData();
          if (rowData._children) {
            if (!rowData.statusGrupo) return '';
            const status = rowData.statusGrupo.descricao;
            const isVinculado = rowData.statusGrupo.id === STATUS_GRUPO.VINCULADO.id;
            return `<div class="status-tooltip-container"><span class="status-badge" style="background:${isVinculado ? '#28a745' : '#6c757d'}; color: white;">${status}</span>${isVinculado ? '<div class="status-tooltip">Cliente com histórico nos últimos 2 anos</div>' : ''}</div>`;
          } else {
            // Solicitação aprovada para esta turma (ano + semestre; a solicitação guarda os dois separados)
            const [anoLinha, semestreLinha] = String(rowData.ano || rowData.Ano_Form).split('/');
            const solicitacaoAprovada = solicitacoesRef.current.find(s =>
              s.status === 'aprovado' &&
              String(s.id_grupo) === String(rowData.id_curso_inst_representante || rowData.id_curso_inst) &&
              String(s.ano_atendimento) === anoLinha &&
              (!s.semestre_atendimento || String(s.semestre_atendimento) === semestreLinha)
            );
            

            let statusParaExibir = null;
            if (solicitacaoAprovada) {
              statusParaExibir = 'SOLICITADO';
            } else if (rowData.CategoriaStatus) {
            }

            if (statusParaExibir) {
              const corFundo = categoriaStatusCores[statusParaExibir] || '#6c757d';
              const corTexto = ['CONTATO OK', 'SEM CONTATO', 'HISTORICO'].includes(statusParaExibir) ? 'black' : 'white';
              return `<span class="status-badge" style="background:${corFundo}; color: ${corTexto};">${statusParaExibir}</span>`;
            }
            
            return ''; 
          }
        }
      },
      {
        title: "Contato",
        field: 'historicoValido',
        width: 140,
        headerSort: false,
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Período válido para contato com o cliente (120 dias antes da formatura)">Contato</span>',
        hozAlign: 'center',
        formatter: (cell) => {
          const rowData = cell.getRow().getData();
          if (rowData._children) {
            const cor = rowData.statusGrupo && rowData.statusGrupo.id === STATUS_GRUPO.VINCULADO.id ? categoriaStatusCores['CONTATO OK'] : categoriaStatusCores['SEM CONTATO'];
            const texto = rowData.statusGrupo && rowData.statusGrupo.id === STATUS_GRUPO.VINCULADO.id ? 'CONTATO OK' : 'SEM CONTATO';

            // Se for CONTATO OK, adicionar link para o lead mais recente
            if (texto === 'CONTATO OK' && rowData._children && rowData._children.length > 0) {
              // Encontrar o lead mais recente com idNegocioBitrix
              const leadMaisRecente = rowData._children
                .filter(child => child.idNegocioBitrix && child.idNegocioBitrix !== '')
                .sort((a, b) => {
                  const [anoA, semestreA] = String(a.Ano_Form).split('/').map(x => parseInt(x, 10));
                  const [anoB, semestreB] = String(b.Ano_Form).split('/').map(x => parseInt(x, 10));

                  if (anoB !== anoA) return anoB - anoA; // Ano mais recente primeiro
                  return (semestreB || 1) - (semestreA || 1); // Semestre mais recente primeiro
                })[0];

              if (leadMaisRecente && leadMaisRecente.idNegocioBitrix) {
                const bitrixUrl = `https://alphae.bitrix24.com.br/crm/deal/details/${leadMaisRecente.idNegocioBitrix}/`;
                return `<a href="${bitrixUrl}" target="_blank" class="status-badge-link" style="text-decoration: none;"><span class="status-badge" style="background:${cor}; color: black; cursor: pointer;" title="Abrir lead no Bitrix24">${texto}</span></a>`;
              }
            }

            return `<span class="status-badge" style="background:${cor}; color: black;">${texto}</span>`;
          } else {
            if (rowData.CategoriaStatus) {
              const cor = categoriaStatusCores[rowData.CategoriaStatus] || '#6c757d';
              const corTexto = (rowData.CategoriaStatus === 'CONTATO OK' || rowData.CategoriaStatus === 'SEM CONTATO') ? 'black' : 'white';

              // Se for CONTATO OK e tiver idNegocioBitrix, adicionar link
              if (rowData.CategoriaStatus === 'CONTATO OK' && rowData.idNegocioBitrix && rowData.idNegocioBitrix !== '') {
                const bitrixUrl = `https://alphae.bitrix24.com.br/crm/deal/details/${rowData.idNegocioBitrix}/`;
                return `<a href="${bitrixUrl}" target="_blank" class="status-badge-link" style="text-decoration: none;"><span class="status-badge" style="background:${cor}; color: ${corTexto}; cursor: pointer;" title="Abrir lead no Bitrix24">${rowData.CategoriaStatus}</span></a>`;
              }

              return `<span class="status-badge" style="background:${cor}; color: ${corTexto};">${rowData.CategoriaStatus}</span>`;
            }
            return '';
          }
        }
      },

      {
        title: "Sigla",
        field: 'sigla_instituicao',
        headerSort: false,
        width: 90,
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Sigla abreviada da instituição de ensino">Sigla</span>',
        hozAlign: 'center',
        formatter: (cell) => cell.getValue()
      },

      {
        title: "Curso",
        field: 'nomecurso',
        width: 150,
        headerSort: false,
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Nome do curso oferecido pela instituição">Curso</span>',
        hozAlign: 'left',
        formatter: (cell) => cell.getValue()
      },

      {
        title: "Cidade",
        field: 'nomecidade',
        width: 110,
        headerSort: false,
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Cidade onde está localizada a instituição">Cidade</span>',
        hozAlign: 'left',
        formatter: (cell) => cell.getValue()
      },

      {
        title: "UF",
        field: 'siglaestado',
        width: 50,
        headerSort: false,
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Unidade Federativa (estado) da instituição">UF</span>',
        hozAlign: 'center',
        formatter: (cell) => cell.getValue()
      },

      {
        title: "Vendedor",
        field: 'vendedor_id',
        headerSort: false,
        width: 180,
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Vendedor responsável pelo atendimento do cliente">Vendedor</span>',
        hozAlign: 'center',
        minWidth: 180,
        maxWidth: 180,
        formatter: vendedorFormatter,
        cellClick: (e, cell) => {
          if (e.target.classList.contains('vendedor-btn-cell')) {
            e.preventDefault();
            e.stopPropagation();
            const row = cell.getRow();
            const rowData = row.getData();

            const dropdown = document.createElement('div');
            dropdown.className = 'vendedor-dropdown';
            vendedores.forEach(vendedor => {
              const option = document.createElement('div');
              option.className = 'vendedor-option';
              option.textContent = vendedor.nome;
              if (String(vendedor.id) === String(rowData.vendedor_id)) {
                option.style.fontWeight = 'bold';
              }
              option.addEventListener('click', () => {
                setAtualizando(true);
                document.body.removeChild(dropdown);
                
                const payload = {
                  id_curso_inst: rowData.id_curso_inst,
                  vendedorId: vendedor.id,
                  vendedorNome: vendedor.nome,
                  ano: rowData.Ano_Form
                };


                // Salvar scroll antes da operação
                salvarPosicaoScroll();

                axios.put(`${REQUEST_URL}/relatorio-vendas/vendedor`, payload)
                  .then((res) => {
                    toast.success('Vendedor alterado com sucesso!');

                    // Usar dados confirmados pelo servidor para garantir consistência
                    const rec = res.data && res.data.updatedRecord;
                    const currentData = row.getData();
                    currentData.vendedor_id = rec ? rec.vendedor_id : vendedor.id;
                    currentData.vendedor = rec ? rec.vendedor : vendedor.nome;
                    currentData.nome_vendedor = rec ? rec.vendedor : vendedor.nome;

                    row.reformat();
                    setTimeout(() => restaurarPosicaoScroll(), 50);
                  })
                  .catch(err => {
                    const responseData = err.response && err.response.data ? err.response.data : null;
                    const errorMessage = responseData && responseData.message
                      ? responseData.message
                      : 'Não foi possível alterar o vendedor.';
                    toast.error(errorMessage);
                  })
                  .finally(() => {
                    setAtualizando(false);
                  });
              });
              dropdown.appendChild(option);
            });

            document.body.appendChild(dropdown);
            const rect = e.target.getBoundingClientRect();
            dropdown.style.left = `${rect.left}px`;
            dropdown.style.top = `${rect.bottom + 5}px`;

            // Prevenir que o clique no botão feche o dropdown imediatamente
            e.stopPropagation();

            const closeDropdown = (event) => {
              if (dropdown && document.body.contains(dropdown) && !dropdown.contains(event.target) && event.target !== e.target) {
                try {
                  document.body.removeChild(dropdown);
                } catch (err) {
                  // Dropdown já foi removido
                }
                document.removeEventListener('click', closeDropdown);
              }
            };
            // Usar timeout maior para evitar fechamento imediato
            setTimeout(() => document.addEventListener('click', closeDropdown), 200);
          }
        }
      },

      {
        title: "Relacionar",
        field: "relacionar_vendedor",
        headerSort: false,
        width: 130,
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Ação para relacionar ou alterar o vendedor responsável">Relacionar</span>',
        hozAlign: 'center',
        minWidth: 130,
        maxWidth: 130,
        formatter: relacionarVendedorFormatter,
        cellClick: (e, cell) => {
          if (e.target.classList.contains('relacionar-vendedor-btn')) {
            e.preventDefault();
            e.stopPropagation();
            const parentRow = cell.getRow();
            const parentData = parentRow.getData();
            const dropdown = document.createElement('div');
            dropdown.className = 'vendedor-dropdown';
            vendedores.forEach(vendedor => {
              const option = document.createElement('div');
              option.className = 'vendedor-option';
              option.textContent = vendedor.nome;

              option.addEventListener('click', () => {
                // Salvar scroll antes da operação
                salvarPosicaoScroll();

                setAtualizando(true);
                document.body.removeChild(dropdown);
                const temNegocio = (d) => d.idNegocioBitrix != null &&
                  !['', '0', 'null', 'undefined'].includes(String(d.idNegocioBitrix).trim());
                const turmas = parentRow.getTreeChildren() || [];
                // Só grava nas turmas livres que existem no banco: turma com negócio ou status
                // mantém o vendedor dela, e linha vazia (sem registro) não tem onde gravar.
                const turmasLivres = turmas.filter(childRow => {
                  const d = childRow.getData();
                  return !d._placeholder && !d.Status && !d.CategoriaStatus && !temNegocio(d);
                });
                if (turmasLivres.length === 0) {
                  toast.info('Nenhuma turma livre deste curso para relacionar: as turmas com negócio mantêm o vendedor delas.');
                  setAtualizando(false);
                  return;
                }

                const gravacoes = turmasLivres.map(childRow => {
                  const d = childRow.getData();
                  return axios.put(`${REQUEST_URL}/relatorio-vendas/vendedor`, {
                    id_curso_inst: d.id_curso_inst,
                    vendedorId: vendedor.id,
                    vendedorNome: vendedor.nome,
                    ano: d.Ano_Form
                  }).then(resposta => ({ childRow, resposta }), erro => ({ childRow, erro }));
                });

                Promise.all(gravacoes)
                  .then((resultados) => {
                    const gravadas = resultados.filter(r => !r.erro);
                    const falhas = resultados.length - gravadas.length;

                    // Usar dados confirmados pelo servidor para cada turma gravada
                    gravadas.forEach(({ childRow, resposta }) => {
                      const childData = childRow.getData();
                      const rec = resposta.data && resposta.data.updatedRecord;
                      childData.vendedor_id = rec ? rec.vendedor_id : vendedor.id;
                      childData.vendedor = rec ? rec.vendedor : vendedor.nome;
                      childData.nome_vendedor = rec ? rec.vendedor : vendedor.nome;
                      childRow.reformat();
                    });

                    // A linha principal mostra o vendedor da turma com negócio; só troca se não houver
                    const cursoTemNegocio = turmas.some(childRow => temNegocio(childRow.getData()));
                    if (gravadas.length > 0 && !cursoTemNegocio) {
                      const parentData = parentRow.getData();
                      parentData.vendedor_id = vendedor.id;
                      parentData.vendedor = vendedor.nome;
                      parentData.nome_vendedor = vendedor.nome;
                      parentRow.reformat();
                    }

                    if (falhas === 0) {
                      toast.success(`Vendedor ${vendedor.nome} relacionado a ${gravadas.length} turma(s) livre(s).`);
                    } else if (gravadas.length > 0) {
                      toast.warn(`${gravadas.length} turma(s) relacionada(s) a ${vendedor.nome}, mas ${falhas} não puderam ser gravada(s). Atualize a página e tente de novo.`);
                    } else {
                      toast.error('Não foi possível atualizar o vendedor do grupo.');
                    }

                    setTimeout(() => restaurarPosicaoScroll(), 50);
                  })
                  .finally(() => {
                    setAtualizando(false);
                  });
              });
              dropdown.appendChild(option);
            });

            document.body.appendChild(dropdown);
            const rect = e.target.getBoundingClientRect();
            dropdown.style.left = `${rect.left}px`;
            dropdown.style.top = `${rect.bottom + 5}px`;

            // Prevenir que o clique no botão feche o dropdown imediatamente
            e.stopPropagation();

            const closeDropdown = (event) => {
              if (dropdown && document.body.contains(dropdown) && !dropdown.contains(event.target) && event.target !== e.target) {
                try {
                  document.body.removeChild(dropdown);
                } catch (err) {
                  // Dropdown já foi removido
                }
                document.removeEventListener('click', closeDropdown);
              }
            };
            // Usar timeout maior para evitar fechamento imediato
            setTimeout(() => document.addEventListener('click', closeDropdown), 200);
          }
        }
      },

      {
        title: "Range",
        field: "range",
        headerSort: false,
        width: 180,
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Período de validade para contato (120 dias antes da formatura)">Range</span>',
        hozAlign: 'center',
        formatter: (cell) => {
          const rowData = cell.getRow().getData();
          if (rowData._children) return '';

          try {
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);

            const anoTurma = parseInt(String(rowData.Ano_Form).split('/')[0], 10);
            if (isNaN(anoTurma)) return '';

            
            if (!rowData.Ano_Form || rowData.Ano_Form === '') return '';

      
            const dataFinalPadrao = new Date(anoTurma, 0, 1); 
            dataFinalPadrao.setDate(dataFinalPadrao.getDate() - 120); 

            
            let dataFinal = dataFinalPadrao;

            if (rowData.range_end_date) {
              // A data vem do banco como dia (meia-noite UTC): ler em UTC para não voltar um dia
              const dataCustomizada = new Date(rowData.range_end_date);
              const mes = dataCustomizada.getUTCMonth();
              const dia = dataCustomizada.getUTCDate();
              const ano = dataCustomizada.getUTCFullYear();

           
              if (mes === 11 && dia === 31 && ano === anoTurma) {
                dataFinal = dataFinalPadrao;
              } else {
                dataFinal = dataCustomizada;
              }
            }

            const dataInicial = null;

            const diffTime = dataFinal - hoje;
            const diasRestantes = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            const formataData = (data) => new Date(data).toLocaleDateString('pt-BR', { timeZone: 'UTC' });

            // Verificar se o vendedor logado tem permissão para estender o range
            const statusFechado = rowData.CategoriaStatus === 'FECHADOS';
            const vendedorRelacionado = rowData.vendedor_id && String(rowData.vendedor_id) === String(usuarioLogado.id);

            // Verificar se há solicitação aprovada para este vendedor neste ano/semestre
            const anoSemestreAtual = String(rowData.Ano_Form);
            const solicitacaoAprovada = solicitacoesRef.current.find(s =>
              s.status === 'aprovado' &&
              String(s.id_grupo) === String(rowData.id_curso_inst_representante || rowData.id_representante) &&
              String(s.id_vendedor_solicitante) === String(usuarioLogado.id) &&
              String(s.ano_atendimento) === anoSemestreAtual.split('/')[0] &&
              String(s.semestre_atendimento) === anoSemestreAtual.split('/')[1]
            );

            // Se for FECHADOS, mostrar "Concluído" em verde
            let textoDias, corDias;
            if (statusFechado) {
              textoDias = 'Concluído';
              corDias = '#28a745';
            } else {
              textoDias = diasRestantes < 0 ? 'Vencido' : `${diasRestantes} dias`;
              corDias = diasRestantes < 0 ? '#dc3545' : (diasRestantes < 30 ? '#fd7e14' : '#28a745');
            }

            // Mostrar botão apenas se: não for FECHADO E (vendedor relacionado OU solicitação aprovada)
            // Linha vazia (turma sem registro no banco) não tem o que estender
            const podeEstenderRange = !rowData._placeholder && !statusFechado && (vendedorRelacionado || solicitacaoAprovada);
            const botaoRange = podeEstenderRange ? `<button class="relacionar-vendedor-btn" style="height: 24px; font-size: 0.8rem; padding: 2px 8px;" data-id="${rowData.id_curso_inst}" data-ano="${rowData.Ano_Form}">+60d</button>` : '';

            return `
                    <div style="font-size: 0.8rem; line-height: 1.2; text-align: left; padding: 4px;">
                        <div>Até ${formataData(dataFinal)}</div>
                        <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 4px;">
                            <span style="font-weight: bold; color: ${corDias};">${textoDias}</span>
                            ${botaoRange}
                        </div>
                    </div>`;
          } catch (error) {
            return 'Erro';
          }
        },
        cellClick: (e, cell) => {
          if (e.target.tagName === 'BUTTON') {
            handleExtendRange(cell);
          }
        }
      },

      {
        title: "Timeline",
        field: "timeline",
        headerSort: false,
        width: 200,
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Histórico de status e negociações do cliente ao longo dos anos">Timeline</span>',
        hozAlign: 'center',
        formatter: timelineFormatter
      },

      {
        title: "Ano",
        field: 'Ano_Form',
        width: 90,
        hozAlign: 'center',
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Ano de formatura da turma">Ano</span>',
        headerSort: false,
        formatter: (cell) => {
          const rowData = cell.getRow().getData();
          if (rowData._children) return '';

          const valor = cell.getValue();
          if (!valor || valor === '' || valor === null || valor === undefined) return '';

          return valor;
        }
      },
      {
        title: "Solicitação",
        field: "solicitacao",
        headerSort: false,
        width: 130,
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Sistema de prioridade e solicitações">Solicitação</span>',
        hozAlign: 'center',
        formatter: (cell) => {
          const rowData = cell.getRow().getData();

          // LINHA PAI (grupo de instituição/curso)
          if (rowData._children) {
            return '<span style="color: #999; font-size: 0.8rem;"></span>';
          }

          // LINHA FILHA (ano/semestre específico)
          if (rowData.Ano_Form) {
            const podeAprovar = podeAprovarSolicitacoes(usuarioLogado);
            const podeSolicitar = podeSolicitarVinculacao(usuarioLogado);

            // ID do grupo (pode ser id_representante ou id_curso_inst)
            const idGrupo = rowData.id_representante || rowData.id_curso_inst;

            // Buscar solicitações deste ano/semestre específico
            const anoSemestreAtual = String(rowData.Ano_Form);
            const solicitacaoPendente = solicitacoesRef.current.find(s =>
              String(s.id_grupo) === String(idGrupo) &&
              s.status === 'pendente' &&
              String(s.ano_atendimento) === anoSemestreAtual.split('/')[0] &&
              String(s.semestre_atendimento) === anoSemestreAtual.split('/')[1]
            );

            const solicitacaoAprovada = solicitacoesRef.current.find(s =>
                String(s.id_grupo) === String(idGrupo) &&
                s.status === 'aprovado' &&
                String(s.id_vendedor_solicitante) === String(usuarioLogado.id) &&
                String(s.ano_atendimento) === anoSemestreAtual.split('/')[0] &&
                String(s.semestre_atendimento) === anoSemestreAtual.split('/')[1]
            );

            const solicitacaoVencida = solicitacoesRef.current.find(s =>
                String(s.id_grupo) === String(idGrupo) &&
                s.status === 'vencido' &&
                String(s.id_vendedor_solicitante) === String(usuarioLogado.id) &&
                String(s.ano_atendimento) === anoSemestreAtual.split('/')[0] &&
                String(s.semestre_atendimento) === anoSemestreAtual.split('/')[1]
            );

            // Verificar status deste ano/semestre específico
            const statusAtual = rowData.CategoriaStatus;
            const statusBloqueado = statusAtual === 'EM NEGOCIAÇÃO' || statusAtual === 'FECHADOS';

            // Verificar se o usuário logado é o vendedor relacionado
            const prioridadeDoUsuarioLogado = rowData.vendedor_id && String(rowData.vendedor_id) === String(usuarioLogado.id);

            // 1. AVALIAÇÃO DE SOLICITAÇÃO (maior prioridade)
            if (solicitacaoPendente && podeAprovar && permissaoRelatorio !== 'ver') {
              return `<button class="btn-aprovacao" data-id="${solicitacaoPendente.id}" style="background: #ffc107; color: #000;">Avaliar</button>`;
            }

            // 2. SE O USUÁRIO LOGADO É O PRÓPRIO VENDEDOR RELACIONADO = NÃO MOSTRAR BOTÃO (pode orçar diretamente)
            if (prioridadeDoUsuarioLogado) {
              if (statusAtual === 'FECHADOS') {
                return '<span style="font-size: 0.8rem; color: #28a745; font-weight: 600; background: #d4edda; padding: 4px 8px; border-radius: 4px; border: 1px solid #28a745;">PRIORIDADE</span>';
              }
              if (statusAtual === 'EM NEGOCIAÇÃO') {
                return '<span style="font-size: 0.8rem; color: #007bff; font-weight: 600;">EM NEGOCIAÇÃO</span>';
              }
              return '<span style="color: #999; font-size: 0.8rem;"></span>';
            }

            // 3. SE TEM SOLICITAÇÃO PENDENTE (visão do solicitante ou de terceiros)
            if (solicitacaoPendente) {
                if (String(solicitacaoPendente.id_vendedor_solicitante) === String(usuarioLogado.id)) {
                    return '<span style="font-size: 0.8rem; color: #ffc107; font-weight: 600;">SOLICITADO</span>';
                }
                return '<span style="font-size: 0.8rem; color: #ffc107; font-weight: 600;">EM ANÁLISE</span>';
            }

            // 4. SE O USUÁRIO TEM SOLICITAÇÃO APROVADA VÁLIDA
            if (solicitacaoAprovada) {
                const diasRestantes = Math.ceil((new Date(solicitacaoAprovada.prazo_fim) - new Date()) / (1000 * 60 * 60 * 24));

                if (diasRestantes < 0 && podeSolicitar && !statusBloqueado) {
                    return `<button class="btn-solicitar-vinculacao" data-id="${idGrupo}" data-ano-semestre="${anoSemestreAtual}" data-grupo='${JSON.stringify(rowData)}'>SOLICITAR</button>`;
                }

                // Se prazo válido, verificar se pode prorrogar
                const podeProrrogar = !solicitacaoAprovada.prorrogacao_usada;

                if (diasRestantes <= 2 && podeProrrogar) {
                    return `<div style="display: inline-flex; gap: 4px; align-items: center; justify-content: center;">
                        <span style="font-size: 0.75rem; color: #dc3545; font-weight: 600; background: #fff3cd; padding: 3px 6px; border-radius: 3px; border: 1px solid #ffc107; white-space: nowrap; line-height: 1.2;" title="Prazo restante">${diasRestantes}d</span>
                        <button class="btn-prorrogar-prazo" data-id-solicitacao="${solicitacaoAprovada.id}" style="font-size: 0.7rem; padding: 3px 5px; background: #007bff; color: white; border: none; border-radius: 3px; cursor: pointer; white-space: nowrap; line-height: 1.2; font-weight: 500;" title="Prorrogar por mais 5 dias">+5d</button>
                    </div>`;
                } else {
                    const corAviso = diasRestantes <= 2 ? '#ffc107' : '#28a745';
                    const corFundo = diasRestantes <= 2 ? '#fff3cd' : '#d4edda';
                    return `<span style="font-size: 0.75rem; color: ${corAviso}; font-weight: 600; background: ${corFundo}; padding: 4px 8px; border-radius: 4px; border: 1px solid ${corAviso};" title="Prazo restante para orçar">${diasRestantes}d restantes</span>`;
                }
            }

            // 5. SOLICITAÇÃO VENCIDA - Pode solicitar novamente
            if (solicitacaoVencida && podeSolicitar && !statusBloqueado) {
                return `<button class="btn-solicitar-vinculacao" data-id="${idGrupo}" data-ano-semestre="${anoSemestreAtual}" data-grupo='${JSON.stringify(rowData)}'>SOLICITAR</button>`;
            }

            // 6. STATUS "FECHADOS" (para outros vendedores) - NÃO PODE SOLICITAR
            if (statusAtual === 'FECHADOS') {
              return '<span style="font-size: 0.8rem; color: #e85d04; font-weight: 600; background: #fff0c2; padding: 4px 8px; border-radius: 4px; border: 1px solid #e85d04;">PRIORIDADE</span>';
            }

            // 7. STATUS "EM NEGOCIAÇÃO" (para outros vendedores) - NÃO PODE SOLICITAR
            if (statusAtual === 'EM NEGOCIAÇÃO') {
              return '<span style="font-size: 0.8rem; color: #999; font-weight: 600;">EM NEGOCIAÇÃO</span>';
            }

            // 8. POSSIBILIDADE DE SOLICITAR (caso geral)
            if (podeSolicitar && !statusBloqueado) {
              return `<button class="btn-solicitar-vinculacao" data-id="${idGrupo}" data-ano-semestre="${anoSemestreAtual}" data-grupo='${JSON.stringify(rowData)}'>SOLICITAR</button>`;
            }

            // 9. CASO PADRÃO
            return '<span style="color: #999; font-size: 0.8rem;"></span>';
          }
          return '';
        },
        cellClick: (e, cell) => {
          if (e.target.classList.contains('btn-cadastrar-contato')) {
            const grupoData = JSON.parse(e.target.getAttribute('data-grupo'));
            window.location.href = '/cadastro';
            toast.info('Redirecionando para cadastro de lead...');
          } else if (e.target.classList.contains('btn-orcamento')) {
            const grupoData = JSON.parse(e.target.getAttribute('data-grupo'));
            window.location.href = '/cadastro';
          } else if (e.target.classList.contains('btn-solicitar-vinculacao')) {
            const grupoData = JSON.parse(e.target.getAttribute('data-grupo'));
            const anoSemestre = e.target.getAttribute('data-ano-semestre');

            // Preencher ano e semestre automaticamente se disponível
            if (anoSemestre) {
              const [ano, semestre] = anoSemestre.split('/');
              setAnoAtendimento(ano || '');
              setSemestreAtendimento(semestre || '');
            } else {
              setAnoAtendimento('');
              setSemestreAtendimento('');
            }

            setGrupoSelecionado(grupoData);
            setModalSolicitacao(true);
          } else if (e.target.classList.contains('btn-aprovacao')) {
            const id = e.target.getAttribute('data-id');
            const solicitacao = solicitacoesRef.current.find(s => String(s.id) === String(id));
            if (solicitacao) {
              setSolicitacaoAtual(solicitacao);
              setModalAprovacao(true);
            }
          } else if (e.target.classList.contains('btn-prorrogar-prazo')) {
            e.preventDefault();
            e.stopPropagation();
            const idSolicitacao = e.target.getAttribute('data-id-solicitacao');

            if (!window.confirm('Deseja prorrogar o prazo por mais 5 dias?')) {
              return;
            }

            axios.post(`${REQUEST_URL}/prioridade/prorrogar/${idSolicitacao}`)
              .then(res => {
                toast.success(res.data.message || 'Prazo prorrogado com sucesso!');
                // Recarregar solicitações
                carregarSolicitacoes();
                // Recarregar dados da tabela mantendo os filtros atuais
                carregarDados(paginaAtual, registrosPorPagina, filtros, false);
              })
              .catch(err => {
                const mensagem = (err.response && err.response.data && err.response.data.message) || 'Erro ao prorrogar prazo.';
                toast.error(mensagem);
              });
          }
        }
      },

      {
        title: "Orçamento",
        field: "orcamento",
        headerSort: false,
        width: 150,
        titleFormatter: () => '<span class="column-header-tooltip" data-tooltip="Botão para realizar orçamento quando em prioridade">Orçamento</span>',
        hozAlign: 'center',
        formatter: (cell) => {
          const rowData = cell.getRow().getData();
          if (rowData._children) {
            const podeAprovar = podeAprovarSolicitacoes(usuarioLogado);
            const podeSolicitar = podeSolicitarVinculacao(usuarioLogado);

            // Verificar se há solicitação aprovada ou em negociação deste grupo, feita pelo
            // vendedor logado (a de outro vendedor não libera o ORÇAR para ele)
            const solicitacaoGrupo = solicitacoes.find(s =>
              (s.status === 'aprovado' || s.status === 'em_negociacao') &&
              String(s.id_vendedor_solicitante) === String(usuarioLogado.id) &&
              (String(s.id_grupo) === String(rowData.id_representante) || String(s.id_grupo) === String(rowData.id))
            );

            // Verificar se o vendedor logado tem prioridade
            const vendedorRelacionado = rowData.vendedor_id && String(rowData.vendedor_id) === String(usuarioLogado.id);

            // Buscar o último status da linha (TODOS os anos, incluindo passados)
            const registrosRecentes = rowData._childrenHistorico || rowData._children || [];

            const registroMaisRecente = registrosRecentes
              .filter(item => {
                const ano = parseInt(String(item.Ano_Form).split('/')[0], 10);
                return !isNaN(ano); // Todos os anos válidos
              })
              .sort((a, b) => {
                const anoA = parseInt(String(a.Ano_Form).split('/')[0], 10);
                const anoB = parseInt(String(b.Ano_Form).split('/')[0], 10);
                return anoB - anoA; // Mais recente primeiro
              })[0];

            const ultimoStatus = registroMaisRecente ? registroMaisRecente.CategoriaStatus : null;
            const statusFechado = ultimoStatus === 'FECHADOS';
            const statusEmNegociacao = ultimoStatus === 'EM NEGOCIAÇÃO';
            const statusPerdido = ultimoStatus === 'PERDIDO';

            // LÓGICA DE LIBERAÇÃO DO BOTÃO ORÇAMENTO

            // PRIORIDADE 1: Se o usuário logado é o próprio vendedor relacionado = SEMPRE LIBERAR (não precisa solicitar)
            if (vendedorRelacionado) {
              return `<button class="btn-orcamento" data-grupo='${JSON.stringify(rowData)}'>ORÇAR</button>`;
            }

            // PRIORIDADE 2: Se há solicitação aprovada = LIBERAR
            if (solicitacaoGrupo && solicitacaoGrupo.status === 'aprovado') {
              return `<button class="btn-orcamento" data-grupo='${JSON.stringify(rowData)}'>ORÇAR</button>`;
            }

            // PRIORIDADE 3: Se SEM VENDEDOR ou VENDEDOR "A definir" = LIVRE (pode orçar diretamente sem precisar solicitar)
            const vendedorNome = getNomeVendedor(rowData.vendedor_id);
            if (!rowData.vendedor_id || vendedorNome === 'A definir') {
              return `<button class="btn-orcamento" data-grupo='${JSON.stringify(rowData)}'>ORÇAR</button>`;
            }

            // PRIORIDADE 4: Se status FECHADOS = Somente com solicitação aprovada
            if (statusFechado) {
              return `<button class="btn-orcamento" disabled data-grupo='${JSON.stringify(rowData)}'>ORÇAR</button>`;
            }

            // PRIORIDADE 5: Se status EM NEGOCIAÇÃO = Somente com solicitação aprovada
            if (statusEmNegociacao) {
              return `<button class="btn-orcamento" disabled data-grupo='${JSON.stringify(rowData)}'>ORÇAR</button>`;
            }

            // PRIORIDADE 6: Se TEM VENDEDOR MAS SEM STATUS = BLOQUEADO (precisa solicitar primeiro)
            if (rowData.vendedor_id && !ultimoStatus) {
              return `<button class="btn-orcamento" disabled data-grupo='${JSON.stringify(rowData)}'>ORÇAR</button>`;
            }

            // PRIORIDADE 7: Caso contrário: botão desabilitado e apagado (não clicável)
            return `<button class="btn-orcamento" disabled data-grupo='${JSON.stringify(rowData)}'>ORÇAR</button>`;
          }
          return '';
        },
        cellClick: (e, cell) => {
          if (e.target.classList.contains('btn-orcamento')) {
            // Botão ORÇAMENTO clicado → Abrir cadastro em nova aba
            const grupoData = JSON.parse(e.target.getAttribute('data-grupo'));

            // Pegar o primeiro child para obter os dados completos
            const firstChild = grupoData._children && grupoData._children[0];

            if (firstChild) {
              // Abrir cadastro em nova aba com dados preenchidos
              const url = `/cadastro?estado=${grupoData.siglaestado}&cidade=${firstChild.cod_cidade}&instituicao=${firstChild.cod_inst}&curso=${firstChild.cod_curso}&semestre=${firstChild.Ano_Form}`;
              window.open(url, '_blank');
            } else {
              window.open('/cadastro', '_blank');
            }
          }
        }
      },
    ];

    // Filtrar colunas baseado na permissão do usuário
    if (permissaoRelatorio === 'ver') {
      return todasColunas.filter(coluna => colunasPermitidas.includes(coluna.field));
    }

    // Retornar todas as colunas para "editar" ou outras permissões
    return todasColunas;
  }, [vendedores, getNomeVendedor, getHistoricoCompletoGrupo, toggleGrupoInstituicao, solicitacoes, usuarioLogado, podeSolicitarVinculacao, podeAprovarSolicitacoes, handleExtendRange, verificarBloqueioSolicitacao, permissaoRelatorio]);

  function handleLimparTodosOsFiltros() {
    setFiltros({
      categoriaStatus: [],
      vendedores: [],
      estados: [],
      instituicoes: [],
      cidades: [],
      cursos: [],
      turnos: [],
      anos: [],
      statusGrupo: [],
      siglas: []
    });
    setBuscaGlobal('');
    setTermoPesquisaFiltro('');
    toast.info('Todos os filtros foram limpos!');
  }

  function handleBuscaGlobal(e) {
    const valor = e.target.value;
    setBuscaGlobal(valor);
  }

  function handlePesquisaFiltro(e) {
    const valor = e.target.value;
    setTermoPesquisaFiltro(valor);
  }

  function aplicarFiltros() {
    toast.success('Filtros aplicados com sucesso!');
  }

  const contarFiltrosAtivos = () => {
    return Object.values(filtros).reduce((total, array) => total + array.length, 0);
  };

  const filtrarOpcoes = useCallback((opcoes, termo) => {
    if (!termo) return opcoes;
    return opcoes.filter(opcao =>
      opcao.toLowerCase().includes(termo.toLowerCase())
    );
  }, []);

  const statusModalFormatter = (categoria, statusDetalhado) => {
    if (!categoria) return '';

    const cor = categoriaStatusCores[categoria] || '#6c757d';

    return `
      <div class="status-tooltip-container">
        <span class="status-badge" style="background:${cor}; color: white;">
          ${categoria}
        </span>
        <div class="status-tooltip">${statusDetalhado || categoria}</div>
      </div>
    `;
  };

  const exportarParaExcel = useCallback(async () => {
    const XLSX = window.XLSX;

    if (!XLSX) {
      toast.error("Biblioteca de exportação não carregada.");
      return;
    }

    const toastId = toast.info('Buscando dados para exportação...', { autoClose: false });

    try {
      aplicarCabecalhoAuthAxios();

      // Usa o endpoint dedicado de exportação — sem chamar Bitrix, sem limit 999999
      const params = {
        buscaGlobal: debouncedBuscaGlobal,
        ...filtros
      };
      // Remover valores vazios para não poluir a query
      Object.keys(params).forEach(k => {
        const v = params[k];
        if (v === '' || v === null || v === undefined || (Array.isArray(v) && v.length === 0)) {
          delete params[k];
        }
      });

      const res = await axios.get(`${REQUEST_URL}/relatorio-vendas/exportar`, {
        params,
        headers: { 'Cache-Control': 'no-cache' },
        timeout: 120000
      });

      const todosOsDados = res.data.data || [];

      if (todosOsDados.length === 0) {
        toast.dismiss(toastId);
        toast.warning('Não há dados para exportar.');
        return;
      }

      // Agrupar por id_curso_inst
      const mapaGrupos = new Map();
      const anoAtual = new Date().getFullYear();

      todosOsDados.forEach(item => {
        const chave = String(item.id_curso_inst);
        if (!mapaGrupos.has(chave)) {
          mapaGrupos.set(chave, {
            nomeintituicao: item.nomeintituicao,
            sigla_instituicao: item.sigla_instituicao,
            nomecurso: item.nomecurso,
            nomecidade: item.nomecidade,
            siglaestado: item.siglaestado,
            nome_vendedor: item.nome_vendedor || item.vendedor || 'A definir',
            _children: []
          });
        }
        mapaGrupos.get(chave)._children.push(item);
      });

      // Ordenar filhos por ano
      mapaGrupos.forEach(grupo => {
        grupo._children.sort((a, b) => {
          const anoA = parseInt(String(a.Ano_Form || a.ano_formatura).split('/')[0], 10);
          const anoB = parseInt(String(b.Ano_Form || b.ano_formatura).split('/')[0], 10);
          return anoA - anoB;
        });

        // Determinar Status Range (Vinculado/Livre) baseado nos últimos 2 anos
        const temVinculo = grupo._children.some(f => {
          const ano = parseInt(String(f.Ano_Form || f.ano_formatura).split('/')[0], 10);
          return ano >= anoAtual - 2 && f.idNegocioBitrix && f.idNegocioBitrix !== '' && f.idNegocioBitrix !== 'null';
        });
        grupo.statusRange = temVinculo ? 'Vinculado' : 'Livre';
      });

      toast.dismiss(toastId);
      toast.info('Gerando planilha...', { autoClose: 2000 });

      const formataData = (data) => {
        try { return new Date(data).toLocaleDateString('pt-BR', { timeZone: 'UTC' }); } catch { return ''; }
      };

      const calcRange = (filho) => {
        try {
          const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
          const anoTurma = parseInt(String(filho.Ano_Form || filho.ano_formatura).split('/')[0], 10);
          if (isNaN(anoTurma)) return '';
          const dataFinalPadrao = new Date(anoTurma, 0, 1);
          dataFinalPadrao.setDate(dataFinalPadrao.getDate() - 120);
          let dataFinal = dataFinalPadrao;
          if (filho.range_end_date) {
            const dc = new Date(filho.range_end_date);
            if (!(dc.getMonth() === 11 && dc.getDate() === 31 && dc.getFullYear() === anoTurma)) {
              dataFinal = dc;
            }
          }
          const dias = Math.ceil((dataFinal - hoje) / (1000 * 60 * 60 * 24));
          return `Até ${formataData(dataFinal)} (${dias < 0 ? 'Vencido' : dias + ' dias'})`;
        } catch { return ''; }
      };

      const linhas = [
        ['Instituição', 'Sigla', 'Curso', 'Cidade', 'UF', 'Vendedor', 'Status Range', 'Ano', 'Range']
      ];

      mapaGrupos.forEach(grupo => {
        // Linha do grupo (cabeçalho)
        linhas.push([
          grupo.nomeintituicao,
          grupo.sigla_instituicao || '',
          grupo.nomecurso || '',
          grupo.nomecidade || '',
          grupo.siglaestado || '',
          grupo.nome_vendedor,
          grupo.statusRange,
          '',
          ''
        ]);
        // Linhas dos anos
        grupo._children.forEach(filho => {
          linhas.push([
            `  ${grupo.nomeintituicao}`,
            grupo.sigla_instituicao || '',
            grupo.nomecurso || '',
            grupo.nomecidade || '',
            grupo.siglaestado || '',
            filho.nome_vendedor || filho.vendedor || 'A definir',
            '',
            String(filho.Ano_Form || filho.ano_formatura || ''),
            calcRange(filho)
          ]);
        });
      });

      const ws = XLSX.utils.aoa_to_sheet(linhas);
      ws['!cols'] = [
        { wch: 42 }, { wch: 10 }, { wch: 32 }, { wch: 20 }, { wch: 5 },
        { wch: 22 }, { wch: 12 }, { wch: 10 }, { wch: 32 }
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Relatório de Vendas');

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const dataAtual = new Date().toLocaleDateString('pt-BR').replace(/\//g, '-');
      saveAs(blob, `relatorio-vendas-${dataAtual}.xlsx`);

      toast.success(`Exportado com sucesso! ${todosOsDados.length} registros.`);

    } catch (error) {
      toast.dismiss(toastId);
      toast.error('Erro ao exportar planilha. Tente novamente.');
    }

  }, [debouncedBuscaGlobal, filtros]);

  if (!sessionStorage.getItem('usuarioLogado')) return <Redirect to="/login" />;

  return (
    <div>
      <ToastContainer position="bottom-left" autoClose={3000} />
      <NavBar nome={usuarioLogado && usuarioLogado.Nome} funcao={usuarioLogado && usuarioLogado.Funcao} />
      <style>{cssExtra}</style>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h1 className="page-title">
              📊 Tabela Vendas
            </h1>
            <p className="page-subtitle">
              Gestão comercial de instituições em contato
            </p>
          </div>

          {/* Dashboard */}
          <DashboardMinimalista
            summary={summaryFiltrado}
            carregando={carregandoSummary}
          />
        </div>
      </div>

      {atualizando && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '12px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            textAlign: 'center'
          }}>
            <div className="loading-spinner"></div>
            <p style={{ marginTop: '16px', marginBottom: '0', fontWeight: 500 }}>Atualizando vendedor...</p>
          </div>
        </div>
      )}

      <Container fluid className="px-3" style={{ height: 'calc(100vh - 80px)', padding: '0' }}>
        <Row className="mb-3" style={{ margin: '0' }}>
          <Col md="12" style={{ padding: '0.5rem' }}>
            <div className="d-flex flex-wrap align-items-center" style={{ gap: '0.5rem' }}>
              {/* --- Busca Global e Limpar Filtros --- */}
              <div className="search-container me-2">
                <span className="search-icon">🔍</span>
                <Input
                  type="text"
                  placeholder="Buscar..."
                  value={buscaGlobal}
                  onChange={handleBuscaGlobal}
                  className="search-input"
                />
                {buscaGlobal && (
                  <button
                    className="clear-search"
                    onClick={() => setBuscaGlobal('')}
                  >
                    ✕
                  </button>
                )}
              </div>
              <Button
                outline
                color="secondary"
                className="filter-btn clear"
                onClick={handleLimparTodosOsFiltros}
                title="Limpar todos os filtros"
              >
                Limpar
              </Button>

              {/* Botão de Exportação para Excel */}
              <Button
                color="success"
                className="export-button"
                onClick={exportarParaExcel}
                title="Exportar dados para Excel"
              >
                📊 Exportar
              </Button>

              {/* --- Botões de Filtro Individuais --- */}

              {/* Filtro de Ano (Sem pesquisa) */}
              <UncontrolledDropdown>
                <DropdownToggle className="filter-button">
                  Ano
                  {filtros.anos.length > 0 && (
                    <span className="filter-count">{filtros.anos.length}</span>
                  )}
                </DropdownToggle>
                <DropdownMenu className="filter-menu">
                  <div className="filter-section">
                    <div className="filter-section-header">
                      <div className="filter-section-title">Filtrar por Ano (2021+)</div>
                      {filtros.anos.length > 0 && (
                        <button
                          className="limpar-filtro-individual-btn"
                          onClick={() => limparFiltroIndividual('anos')}
                        >
                          Limpar
                        </button>
                      )}
                    </div>
                    {anosOptions
                      .filter(ano => parseInt(ano) >= 2021)
                      .map(ano => (
                        <div key={ano} className="filter-option" onClick={() => toggleFiltro('anos', ano)}>
                          <input type="checkbox" checked={filtros.anos.includes(ano)} readOnly />
                          {ano}
                        </div>
                      ))}
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>

              {/* Filtro de Instituição com Pesquisa */}
              <UncontrolledDropdown>
                <DropdownToggle className="filter-button" onClick={() => setPesquisaInstituicao('')}>
                  Instituição
                  {filtros.instituicoes.length > 0 && (
                    <span className="filter-count">{filtros.instituicoes.length}</span>
                  )}
                </DropdownToggle>
                <DropdownMenu className="filter-menu">
                  <div className="filter-section">
                    <div className="filter-section-header">
                      <div className="filter-section-title">Filtrar por Instituição</div>
                      {filtros.instituicoes.length > 0 && (
                        <button
                          className="limpar-filtro-individual-btn"
                          onClick={() => limparFiltroIndividual('instituicoes')}
                        >
                          Limpar
                        </button>
                      )}
                    </div>
                    <Input
                      type="text"
                      placeholder="Pesquisar..."
                      value={pesquisaInstituicao}
                      onChange={(e) => setPesquisaInstituicao(e.target.value)}
                      className="search-input mb-2"
                    />
                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                      {instituicoesOptions
                        .filter(instituicao => instituicao.toLowerCase().includes(pesquisaInstituicao.toLowerCase()))
                        .map(instituicao => (
                          <div key={instituicao} className="filter-option" onClick={() => toggleFiltro('instituicoes', instituicao)}>
                            <input type="checkbox" checked={filtros.instituicoes.includes(instituicao)} readOnly />
                            {instituicao}
                          </div>
                        ))}
                    </div>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown>
                <DropdownToggle className="filter-button" onClick={() => setPesquisaSigla('')}>
                  Sigla
                  {filtros.siglas.length > 0 && (
                    <span className="filter-count">{filtros.siglas.length}</span>
                  )}
                </DropdownToggle>
                <DropdownMenu className="filter-menu">
                  <div className="filter-section">
                    <div className="filter-section-header">
                      <div className="filter-section-title">Filtrar por Sigla</div>
                      {filtros.siglas.length > 0 && (
                        <button
                          className="limpar-filtro-individual-btn"
                          onClick={() => limparFiltroIndividual('siglas')}
                        >
                          Limpar
                        </button>
                      )}
                    </div>
                    <Input
                      type="text"
                      placeholder="Pesquisar..."
                      value={pesquisaSigla}
                      onChange={(e) => setPesquisaSigla(e.target.value)}
                      className="search-input mb-2"
                    />
                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                      {siglasOptions
                        .filter(sigla => sigla.toLowerCase().includes(pesquisaSigla.toLowerCase()))
                        .map(sigla => (
                          <div key={sigla} className="filter-option" onClick={() => toggleFiltro('siglas', sigla)}>
                            <input type="checkbox" checked={filtros.siglas.includes(sigla)} readOnly />
                            {sigla}
                          </div>
                        ))}
                    </div>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown>
                <DropdownToggle className="filter-button">
                  Estado
                  {filtros.estados.length > 0 && (
                    <span className="filter-count">{filtros.estados.length}</span>
                  )}
                </DropdownToggle>
                <DropdownMenu className="filter-menu">
                  <div className="filter-section">
                    <div className="filter-section-header">
                      <div className="filter-section-title">Filtrar por Estado</div>
                      {filtros.estados.length > 0 && (
                        <button
                          className="limpar-filtro-individual-btn"
                          onClick={() => limparFiltroIndividual('estados')}
                        >
                          Limpar
                        </button>
                      )}
                    </div>
                    {estadosOptions.map(estado => (
                      <div key={estado} className="filter-option" onClick={() => toggleFiltro('estados', estado)}>
                        <input type="checkbox" checked={filtros.estados.includes(estado)} readOnly />
                        {estado}
                      </div>
                    ))}
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>

              {/* Bloco de código a ser substituído */}

              <UncontrolledDropdown>
                <DropdownToggle className="filter-button" onClick={() => setPesquisaCurso('')}>
                  Curso
                  {filtros.cursos.length > 0 && (
                    <span className="filter-count">{filtros.cursos.length}</span>
                  )}
                </DropdownToggle>

                <DropdownMenu className="filter-menu">
                  <div className="filter-section">
                    {/* INÍCIO DA MODIFICAÇÃO */}
                    <div className="filter-section-header">
                      <div className="filter-section-title">Filtrar por Curso</div>
                      {filtros.cursos.length > 0 && (
                        <button
                          className="limpar-filtro-individual-btn"
                          onClick={() => limparFiltroIndividual('cursos')}
                        >
                          Limpar
                        </button>
                      )}
                    </div>
                    <Input
                      type="text"
                      placeholder="Pesquisar..."
                      value={pesquisaCurso}
                      onChange={(e) => setPesquisaCurso(e.target.value)}
                      className="search-input mb-2"
                    />
                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                      {cursosOptions
                        .filter(curso => curso.toLowerCase().includes(pesquisaCurso.toLowerCase()))
                        .map(curso => (
                          <div key={curso} className="filter-option" onClick={() => toggleFiltro('cursos', curso)}>
                            <input type="checkbox" checked={filtros.cursos.includes(curso)} readOnly />
                            {curso}
                          </div>
                        ))}
                    </div>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown>
                <DropdownToggle className="filter-button" onClick={() => setPesquisaCidade('')}>
                  Cidade
                  {filtros.cidades.length > 0 && (
                    <span className="filter-count">{filtros.cidades.length}</span>
                  )}
                </DropdownToggle>
                <DropdownMenu className="filter-menu">
                  <div className="filter-section">
                    <div className="filter-section-header">
                      <div className="filter-section-title">Filtrar por Cidade</div>
                      {filtros.cidades.length > 0 && (
                        <button
                          className="limpar-filtro-individual-btn"
                          onClick={() => limparFiltroIndividual('cidades')}
                        >
                          Limpar
                        </button>
                      )}
                    </div>
                    <Input
                      type="text"
                      placeholder="Pesquisar..."
                      value={pesquisaCidade}
                      onChange={(e) => setPesquisaCidade(e.target.value)}
                      className="search-input mb-2"
                    />
                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                      {cidadesOptions
                        .filter(cidade => cidade.toLowerCase().includes(pesquisaCidade.toLowerCase()))
                        .map(cidade => (
                          <div key={cidade} className="filter-option" onClick={() => toggleFiltro('cidades', cidade)}>
                            <input type="checkbox" checked={filtros.cidades.includes(cidade)} readOnly />
                            {cidade}
                          </div>
                        ))}
                    </div>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown>
                <DropdownToggle className="filter-button">
                  Vendedor
                  {filtros.vendedores.length > 0 && (
                    <span className="filter-count">{filtros.vendedores.length}</span>
                  )}
                </DropdownToggle>
                <DropdownMenu className="filter-menu">
                  <div className="filter-section">
                    <div className="filter-section-header">
                      <div className="filter-section-title">Filtrar por Vendedor</div>
                      {filtros.vendedores.length > 0 && (
                        <button
                          className="limpar-filtro-individual-btn"
                          onClick={() => limparFiltroIndividual('vendedores')}
                        >
                          Limpar
                        </button>
                      )}
                    </div>
                    {vendedores.map(v => v.nome).map(vendedor => (
                      <div key={vendedor} className="filter-option" onClick={() => toggleFiltro('vendedores', vendedor)}>
                        <input type="checkbox" checked={filtros.vendedores.includes(vendedor)} readOnly />
                        {vendedor}
                      </div>
                    ))}
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown>
                <DropdownToggle className="filter-button">
                  Status
                  {filtros.categoriaStatus.length > 0 && (
                    <span className="filter-count">{filtros.categoriaStatus.length}</span>
                  )}
                </DropdownToggle>
                <DropdownMenu className="filter-menu">
                  <div className="filter-section">
                    <div className="filter-section-header">
                      <div className="filter-section-title">Filtrar por Status</div>
                      {filtros.categoriaStatus.length > 0 && (
                        <button
                          className="limpar-filtro-individual-btn"
                          onClick={() => limparFiltroIndividual('categoriaStatus')}
                        >
                          Limpar
                        </button>
                      )}
                    </div>
                    {categoriaStatusOptions.map(categoria => (
                      <div key={categoria} className="filter-option" onClick={() => toggleFiltro('categoriaStatus', categoria)}>
                        <input type="checkbox" checked={filtros.categoriaStatus.includes(categoria)} readOnly />
                        {categoria}
                      </div>
                    ))}
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown>
                <DropdownToggle className="filter-button">
                  Sem Contato/Contato Ok
                  {filtros.statusGrupo && filtros.statusGrupo.length > 0 && (
                    <span className="filter-count">{filtros.statusGrupo.length}</span>
                  )}
                </DropdownToggle>
                <DropdownMenu className="filter-menu">
                  <div className="filter-section">
                    <div className="filter-section-header">
                      <div className="filter-section-title">Filtrar por Status do Grupo</div>
                      {filtros.statusGrupo.length > 0 && (
                        <button
                          className="limpar-filtro-individual-btn"
                          onClick={() => limparFiltroIndividual('statusGrupo')}
                        >
                          Limpar
                        </button>
                      )}
                    </div>
                    <div className="filter-option" onClick={() => debouncedToggleFiltro('statusGrupo', 'Livre')}>
                      <input type="checkbox" checked={filtros.statusGrupo ? filtros.statusGrupo.includes('Livre') : false} readOnly />
                      Sem Contato
                    </div>
                    <div className="filter-option" onClick={() => debouncedToggleFiltro('statusGrupo', 'Vinculado')}>
                      <input type="checkbox" checked={filtros.statusGrupo ? filtros.statusGrupo.includes('Vinculado') : false} readOnly />
                      Contato Ok
                    </div>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            {!carregando && dados.length > 0 && totalPaginas > 1 && (
              <PaginationComponent
                paginaAtual={paginaAtual}
                totalPaginas={totalPaginas}
                totalRegistros={totalRegistros}
                registrosPorPagina={registrosPorPagina}
                mudarPagina={mudarPagina}
                carregando={carregando}
              />
            )}
          </Col>
        </Row>
        <Card className="table-container-card">
          <CardBody className="p-0" style={{ height: 'calc(90vh - 130px)', padding: '0' }}>
            {carregando ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Carregando dados...</p>
              </div>
            ) : (
              <ReactTabulator
                onRef={(r) => (tableRef.current = r)}
                columns={colunasTabela}
                data={dadosAgrupados}
                options={{
                  index: 'id',
                  layout: 'fitData',
                  height: "100%",
                  placeholder: "Nenhum dado encontrado.",
                  dataTree: true,
                  dataTreeStartExpanded: false,
                  dataTreeElementColumn: "nomeintituicao",
                  movableColumns: false,
                  resizableRows: false,
                  tooltips: true,
                  columnHeaderVertAlign: "middle",
                  columnHeaderAlign: "center",
                  columnMinWidth: 80,
                  rowHeight: 56,
                  headerHeight: 56,
                  autoColumns: false,
                  autoResize: true,
                  renderVertical: "virtual",
                  renderVerticalBuffer: 300,
                  scrollToRowPosition: "nearest",
                  scrollToColumnPosition: "nearest",
                  autoScrollToRow: false,
                  columnResized: function (column) {
                    if (column.getField() === "timeline") {
                      const table = tableRef.current && tableRef.current.table;
                      if (table) {
                        // Salvar scroll antes de redraw
                        salvarPosicaoScroll();
                        table.redraw();
                        // Restaurar scroll após redraw
                        setTimeout(() => restaurarPosicaoScroll(), 50);
                      }
                    }
                  },
                  dataProcessed: function () {
                    if (dataProcessedTimeout.current) {
                      clearTimeout(dataProcessedTimeout.current);
                    }

                    dataProcessedTimeout.current = setTimeout(() => {
                      const table = tableRef.current && tableRef.current.table;
                      if (table && gruposExpandidos.size > 0) {
                        // Salvar scroll antes de re-expandir
                        salvarPosicaoScroll();
                        reexpandGroups(table, gruposExpandidos);
                        // Restaurar scroll após re-expandir
                        setTimeout(() => restaurarPosicaoScroll(), 100);
                      }
                    }, 100);
                  },
                  dataTreeExpanded: function (row) {
                    const rowData = row.getData();
                    if (rowData._children) {
                      setGruposExpandidos(prev => {
                        const novos = new Set(prev);
                        novos.add(rowData.id);
                        return novos;
                      });
                    }
                  },
                  dataTreeCollapsed: function (row) {
                    const rowData = row.getData();
                    if (rowData._children) {
                      setGruposExpandidos(prev => {
                        const novos = new Set(prev);
                        novos.delete(rowData.id);
                        return novos;
                      });
                    }
                  }
                }}
              />
            )}
          </CardBody>
        </Card>
      </Container>
      {/* Modal para histórico completo */}
      <Modal isOpen={modalTimeline} toggle={() => setModalTimeline(false)} size="lg">
        <ModalHeader toggle={() => setModalTimeline(false)}>
          Histórico Completo
        </ModalHeader>
        <ModalBody>
          {timelineData ? (
            <div>
              <h5>{timelineData.nomeintituicao} - {timelineData.nomecurso}</h5>
              <p><strong>Cidade:</strong> {timelineData.nomecidade} - {timelineData.siglaestado}</p>

              {timelineData._childrenHistorico && timelineData._childrenHistorico.length > 0 ? (
                <Table className="modal-timeline-table">
                  <thead>
                    <tr>
                      <th>Ano</th>
                      <th>Status</th>
                      <th>Vendedor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {timelineData._childrenHistorico
                      .filter(item => {
                        const ano = parseInt(String(item.Ano_Form).split('/')[0], 10);
                        return !isNaN(ano) && ano <= 2024;
                      })
                      .reduce((unique, item) => {
                        const chaveUnica = `${item.id_curso_inst}-${String(item.Ano_Form)}`;
                        if (!unique.some(u => `${u.id_curso_inst}-${String(u.Ano_Form)}` === chaveUnica)) {
                          unique.push(item);
                        }
                        return unique;
                      }, [])
                      .sort((a, b) => {
                        const anoA = parseInt(String(a.Ano_Form).split('/')[0], 10);
                        const anoB = parseInt(String(b.Ano_Form).split('/')[0], 10);
                        return anoB - anoA; // Ordem decrescente (mais recente primeiro)
                      })
                      .map((item, index) => (
                        <tr key={`${item.id_curso_inst}-${item.Ano_Form}-${index}`}>
                          <td>{item.Ano_Form}</td>
                          <td>
                            <span
                              className="status-badge"
                              style={{
                                background: categoriaStatusCores[item.CategoriaStatus] || '#6c757d',
                                color: (item.CategoriaStatus === 'CONTATO OK' || item.CategoriaStatus === 'SEM CONTATO') ? 'black' : 'white'
                              }}
                            >
                              {item.CategoriaStatus || 'Sem status'}
                            </span>
                          </td>
                          <td>{getNomeVendedor(item.vendedor_id)}</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              ) : (
                <div className="alert alert-warning">
                  Nenhum histórico encontrado para este grupo.
                </div>
              )}
            </div>
          ) : (
            <p>Carregando informações do histórico...</p>
          )}
        </ModalBody>
      </Modal>

      {/* Modal para solicitar vinculação */}
      <Modal isOpen={modalSolicitacao} toggle={() => setModalSolicitacao(false)}>
        <ModalHeader toggle={() => setModalSolicitacao(false)}>
          Solicitar Vinculação
        </ModalHeader>
        <ModalBody>
          {grupoSelecionado ? (
            <div>
              <p><strong>Instituição:</strong> {grupoSelecionado.nomeintituicao}</p>
              <p><strong>Curso:</strong> {grupoSelecionado.nomecurso}</p>
              <p><strong>Cidade:</strong> {grupoSelecionado.nomecidade}</p>

              <div className="form-group mt-3">
                <label htmlFor="ano-atendimento">
                  <strong>Ano de Atendimento (Obrigatório)</strong>
                </label>
                <Input
                  type="select"
                  id="ano-atendimento"
                  value={anoAtendimento}
                  onChange={(e) => setAnoAtendimento(e.target.value)}
                  disabled={anoAtendimento !== ''}
                >
                  <option value="">Selecione o ano...</option>
                  {/* Gerar opções de anos dinamicamente. Ex: ano atual até 5 anos no futuro */}
                  {Array.from({ length: 7 }, (_, i) => new Date().getFullYear() + i).map(ano => (
                    <option key={ano} value={ano}>{ano}</option>
                  ))}
                </Input>
                {anoAtendimento !== '' && (
                  <small className="form-text text-muted">
                    Ano/semestre preenchido automaticamente a partir da linha selecionada.
                  </small>
                )}
              </div>

              <div className="form-group mt-3">
                <label htmlFor="semestre-atendimento">
                  <strong>Semestre (Obrigatório)</strong>
                </label>
                <Input
                  type="select"
                  id="semestre-atendimento"
                  value={semestreAtendimento}
                  onChange={(e) => setSemestreAtendimento(e.target.value)}
                  disabled={semestreAtendimento !== ''}
                >
                  <option value="">Selecione o semestre...</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                </Input>
              </div>

              <div className="form-group mt-3">
                <label htmlFor="contato-solicitacao">
                  <strong>Contato (Obrigatório)</strong>
                </label>
                <Input
                  type="text"
                  id="contato-solicitacao"
                  value={contatoSolicitacao}
                  onChange={(e) => setContatoSolicitacao(e.target.value)}
                  placeholder="Ex: João Silva - (11) 98765-4321"
                />
              </div>

              <div className="form-group mt-3">
                <label htmlFor="motivo-solicitacao">
                  <strong>Motivo da Solicitação (Obrigatório)</strong>
                </label>
                <Input
                  type="textarea"
                  id="motivo-solicitacao"
                  value={motivoSolicitacao}
                  onChange={(e) => setMotivoSolicitacao(e.target.value)}
                  placeholder="Ex: Cliente demonstrou interesse em fechar o contrato."
                  rows="3"
                />
              </div>

              {podeSolicitarVinculacao(usuarioLogado) ? (
                <div className="alert alert-info mt-3">
                  {usuarioLogado.Nivel === "SENIOR" && usuarioLogado.Funcao === "ORCAMENTISTA" ? (
                    <span>Você está solicitando vinculação como: <strong>{usuarioLogado.Nome || usuarioLogado.nome || 'Nome não disponível'}</strong> (ORCAMENTISTA)</span>
                  ) : (
                    <span>Você está solicitando vinculação como: <strong>{usuarioLogado.Nome || usuarioLogado.nome || 'Nome não disponível'}</strong> (VENDEDOR)</span>
                  )}
                </div>
              ) : (
                <div className="alert alert-danger mt-3">
                  Você não tem permissão para solicitar vinculação.
                </div>
              )}

              <div className="d-flex justify-content-end mt-4">
                <Button color="secondary" onClick={() => setModalSolicitacao(false)}>
                  Cancelar
                </Button>
                {podeSolicitarVinculacao(usuarioLogado) && (
                  <Button color="primary" onClick={enviarSolicitacao} className="ms-2">
                    Confirmar Solicitação
                  </Button>
                )}
              </div>
            </div>
          ) : (
            <p>Nenhum grupo selecionado.</p>
          )}
        </ModalBody>
      </Modal>

      {/* Modal para aprovação/rejeição (Marketing ou Administrador) */}
      {modalAprovacao && (
        <Modal isOpen={modalAprovacao} toggle={() => setModalAprovacao(false)}>
          <ModalHeader toggle={() => setModalAprovacao(false)}>
            Avaliar Solicitação de Vinculação
          </ModalHeader>
          <ModalBody>
            {solicitacaoAtual ? (
              <div>
                <p><strong>Instituição:</strong> {solicitacaoAtual.nome_instituicao}</p>
                <p><strong>Curso:</strong> {solicitacaoAtual.nome_curso}</p>
                <p><strong>Vendedor Solicitante:</strong> {solicitacaoAtual.nome_vendedor_solicitante}</p>
                <p><strong>Data da Solicitação:</strong> {new Date(solicitacaoAtual.data_solicitacao).toLocaleString()}</p>

                <div className="form-group mt-3">
                  <label>Justificativa (opcional):</label>
                  <Input
                    type="textarea"
                    value={justificativa}
                    onChange={(e) => setJustificativa(e.target.value)}
                    placeholder="Informe o motivo da decisão"
                  />
                </div>

                <div className="d-flex justify-content-end mt-4">
                  <Button color="secondary" onClick={() => setModalAprovacao(false)}>
                    Cancelar
                  </Button>
                  <Button
                    color="danger"
                    onClick={() => aprovarSolicitacao(solicitacaoAtual.id, false)}
                    className="ms-2"
                  >
                    Rejeitar
                  </Button>
                  <Button
                    color="success"
                    onClick={() => aprovarSolicitacao(solicitacaoAtual.id, true)}
                    className="ms-2"
                  >
                    Aprovar
                  </Button>
                </div>
              </div>
            ) : (
              <p>Carregando informações da solicitação...</p>
            )}
          </ModalBody>
        </Modal>
      )}
    </div>
  );
}

export default RelatorioVendas;